/* ============================================================================
 * FILTER SYSTEM CONFIGURATION
 * ============================================================================
 * 
 * IMPORTANT: Update these values when copying to a new Shopify site!
 * 
 * Option 1: Use window.filterConfig (recommended)
 *   - Include snippets/filter-config.liquid in your theme before this script
 *   - Values will be automatically loaded from configuration
 * 
 * Option 2: Update values directly below
 *   - Change SHOPIFY_DOMAIN to your store's domain
 *   - Change STOREFRONT_ACCESS_TOKEN to your Storefront API token
 *   - Adjust other values as needed
 * ============================================================================ */

// Shopify API Configuration
// Get from window.filterConfig if available, otherwise use defaults
const CONFIG = window.filterConfig || {};
const SHOPIFY_DOMAIN = CONFIG.shopifyDomain || 'estate-watch-and-jewelry-company.myshopify.com'; // ⚠️ CHANGE THIS for new site
const API_VERSION = CONFIG.apiVersion || '2023-07';
const STOREFRONT_ACCESS_TOKEN = CONFIG.storefrontAccessToken || '112d8c355bff7f3c728e47bb0495aaae'; // ⚠️ CHANGE THIS for new site

// Build GraphQL API URL
const GRAPHQL_API_URL = `https://${SHOPIFY_DOMAIN}/api/${API_VERSION}/graphql.json`;

// Pagination Settings
const PRODUCTS_PER_PAGE = CONFIG.productsPerPage || 24; // Products shown per page
const GRAPHQL_PAGE_SIZE = 250; // Products fetched per GraphQL request (max 250)

// Collection Handle Extraction
// Default: extracts from URL path (e.g., /collections/rings -> "rings")
// Override if your URL structure is different
function getCollectionHandle() {
  if (CONFIG.getCollectionHandle && typeof CONFIG.getCollectionHandle === 'function') {
    return CONFIG.getCollectionHandle();
  }
  return window.location.pathname.split("/")[2];
}

/* ============================================================================
 * END CONFIGURATION
 * ============================================================================ */

// Fetch state management - prevents duplicate fetches
let fetchPromise = null;
let isFetching = false;

// Create applyFilter immediately so it's available (placeholder until main one loads)
window.applyFilter = async function() {
  // Placeholder until main applyFilter loads
};

var all_products = [],
  filter_products = [];
var currentPage = 1;

// Helper function to get fresh empty filter state
function getEmptyFilters() {
  return {
    material: [],
    stones: [],
    stonesDesigner: [],
    price: [],
    designer: [],
    length: [],
    stoneShape: [],
    stoneSize: [],
    diamondColor: [],
    diamondClarity: [],
    certificate: [],
    ringType: [],
    material_band: [],
    gender: [],
    watchMaterial: [],
    materialType: [],
    movement: [],
    caseSize: [],
    productType: [],
    condition: [],
    earringType: [],
    hangingType: [],
    studSize: [],
  };
}

// Detect navigation type to determine if we should restore filters
// - 'reload' = hard refresh (F5, Cmd+R) -> clear filters
// - 'back_forward' = browser back/forward button -> restore filters
// - 'navigate' = clicking a link -> clear filters
function getNavigationType() {
  try {
    const entries = performance.getEntriesByType('navigation');
    if (entries.length > 0) {
      return entries[0].type; // 'navigate', 'reload', 'back_forward', or 'prerender'
    }
  } catch (e) {
    // Navigation detection failed
  }
  return 'navigate'; // Default to navigate (clear filters)
}

const navigationType = getNavigationType();
const isBackForwardNavigation = navigationType === 'back_forward';
const isHardRefresh = navigationType === 'reload';

// Check if we're on a collection page
const currentPath = window.location.pathname;
const isCollectionPage = currentPath.includes('/collections/') && !currentPath.includes('/products/');
const currentHandle = currentPath.split("/")[2] || '';

// Navigation detection complete

// Initialize selectedFilters based on navigation type
var selectedFilters;
if (isBackForwardNavigation) {
  // Back/forward navigation - try to restore from sessionStorage
  const savedFilters = sessionStorage.getItem('filter-state');
  const savedHandle = sessionStorage.getItem('filter-collection-handle');
  
  if (savedFilters && savedHandle === currentHandle) {
    try {
      selectedFilters = JSON.parse(savedFilters);
    } catch (e) {
      selectedFilters = getEmptyFilters();
    }
  } else {
    selectedFilters = getEmptyFilters();
  }
} else if (isHardRefresh && isCollectionPage) {
  // Hard refresh on collection page - clear filters
  selectedFilters = getEmptyFilters();
  sessionStorage.removeItem('filter-state');
} else if (!isCollectionPage) {
  // Not on a collection page - don't touch sessionStorage, just use empty filters for this script
  selectedFilters = getEmptyFilters();
} else {
  // Fresh navigation to a collection page - start with empty filters
  selectedFilters = getEmptyFilters();
  // Only clear if navigating to a DIFFERENT collection
  const savedHandle = sessionStorage.getItem('filter-collection-handle');
  if (savedHandle && savedHandle !== currentHandle) {
    sessionStorage.removeItem('filter-state');
  }
}

const materialFitlerSelector = '.fiter-material .dropdown-content .parent-option>label>input[type="checkbox"]';

const materialBandsFitlerSelector = '.fiter-material-bands .dropdown-content .parent-option>label>input[type="checkbox"]';

const stonesFitlerSelector = '.fiter-stones .dropdown-content .parent-option>label>input[type="checkbox"]';

const stonesDesignerFitlerSelector = '.fiter-stones-designers .dropdown-content .parent-option>label>input[type="checkbox"]';

const subMenuSelector = '.sub-menu.sub-menu-stones input[type="checkbox"]';

const priceSelector = '.fiter-price .dropdown-content .parent-option>label>input[type="checkbox"]';

const designerSelector = '.fiter-designer .dropdown-content .parent-option>label>input[type="checkbox"]';

const lengthSelector = '.fiter-length .dropdown-content .parent-option>label>input[type="checkbox"]';

const stoneShapeSelector = '.fiter-stone-shape .dropdown-content .parent-option input[type="checkbox"]';

const stoneSizeSelector = '.fiter-stone-size .dropdown-content .parent-option input[type="checkbox"]';

const diamondColorSelector = '.fiter-diamond-color .dropdown-content .parent-option input[type="checkbox"]';

const diamondClaritySelector = '.fiter-diamond-clarity .dropdown-content .parent-option input[type="checkbox"]';

const certificateLabSelector = '.fiter-certificate-lab .dropdown-content .parent-option input[type="checkbox"]';

const ringTypeSelector = '.fiter-ring-type .dropdown-content .parent-option input[type="checkbox"]';

const genderSelector = '.fiter-gender .dropdown-content .parent-option input[type="checkbox"]';

const materialTypeSelector = '.fiter-material-type .dropdown-content .parent-option input[type="checkbox"]';

const movementSelector = '.fiter-movement .dropdown-content .parent-option input[type="checkbox"]';

const caseSizeSelector = '.fiter-case-size .dropdown-content .parent-option input[type="checkbox"]';

const productTypeSelector = '.fiter-product-type .dropdown-content .parent-option input[type="checkbox"]';

const conditionSelector = '.fiter-condition .dropdown-content .parent-option input[type="checkbox"]';

const earringTypeSelector = '.fiter-earring-type .dropdown-content .parent-option>label>input[type="checkbox"]';
const hangingTypeSelector = '.fiter-earring-type .dropdown-content .parent-option .sub-menu input[name="hanging-type"]';
const studSizeSelector = '.fiter-earring-type .dropdown-content .parent-option .sub-menu input[name="stud-size"]';
const earringColoredGemstoneSelector = '.fiter-earring-type .dropdown-content .parent-option .sub-menu input[name="gemstones"]';

// Track if page was restored from bfcache (set early, before jQuery loads)
let wasRestoredFromBfcache = false;

// Add CSS to show spinner overlay during bfcache restore
const addBfcacheStyles = () => {
  if (!document.getElementById('bfcache-hide-styles')) {
    const style = document.createElement('style');
    style.id = 'bfcache-hide-styles';
    style.textContent = `
      /* Hide products instantly during bfcache restore - no transitions */
      body.bfcache-loading .ProductListWrapper {
        visibility: hidden !important;
        opacity: 0 !important;
        transition: none !important;
      }
      body.bfcache-loading .ProductItem__Image,
      body.bfcache-loading .ProductItem__ImageWrapper,
      body.bfcache-loading .ProductItem {
        visibility: hidden !important;
        opacity: 0 !important;
      }
      /* Show the existing spinner overlay during bfcache restore */
      body.bfcache-loading .spinner-overlay {
        opacity: 1 !important;
        visibility: visible !important;
        transition: none !important;
        background: rgba(255, 255, 255, 1) !important;
        pointer-events: auto !important;
      }
    `;
    // Prepend to head so it loads before other styles
    document.head.insertBefore(style, document.head.firstChild);
  }
};
addBfcacheStyles();

// AGGRESSIVE: Check navigation type immediately on script load
// This runs BEFORE DOMContentLoaded, as early as possible
(function() {
  const navType = performance.getEntriesByType?.('navigation')[0]?.type;
  const wasBackForward = navType === 'back_forward';
  
  console.log('%c[EARLY NAVIGATION CHECK]', 'background: #00f; color: #fff;', {
    navigationType: navType,
    isBackForward: wasBackForward
  });
  
  if (wasBackForward) {
    // This is a back/forward navigation - show loading state immediately
    console.log('%c[BACK/FORWARD DETECTED EARLY]', 'background: #f90; color: #000; font-weight: bold;');
    
    // Add class to body as early as possible
    if (document.body) {
      document.body.classList.add('bfcache-loading');
    } else {
      // Body not ready yet - add class as soon as it is
      document.addEventListener('DOMContentLoaded', function() {
        document.body.classList.add('bfcache-loading');
      }, { once: true });
    }
    
    // Store flag for later
    window._wasBackForwardNav = true;
  }
})();

// CRITICAL: Hide products BEFORE user navigates away so they're hidden when bfcache restores
window.addEventListener('pagehide', function(event) {
  console.log('%c[PAGEHIDE EVENT]', 'background: #f00; color: #fff; font-weight: bold;', {
    persisted: event.persisted,
    timestamp: new Date().toISOString()
  });
  
  // Always prepare for potential bfcache, not just when persisted
  // Save scroll position before page is cached
  sessionStorage.setItem('collection-scroll-position', window.scrollY.toString());
  sessionStorage.setItem('collection-scroll-path', window.location.pathname);
  
  // Mark that we're navigating away - this will persist in bfcache
  document.body.classList.add('bfcache-loading');
  
  const productList = document.querySelector('.ProductListWrapper');
  const overlay = document.querySelector('.spinner-overlay');
  
  if (productList) {
    productList.style.visibility = 'hidden';
    productList.style.opacity = '0';
  }
  if (overlay) {
    overlay.classList.add('show');
  }
  
  // Clear ALL product images before caching to prevent showing wrong images on restore
  // Use a broader selector to catch all product images, including lazy-loaded ones
  const allImages = document.querySelectorAll('.ProductItem__Image, .ProductItem img, .ProductList img');
  console.log('[PAGEHIDE] Clearing', allImages.length, 'product images');
  
  allImages.forEach(function(img, idx) {
    if (idx === 0) {
      console.log('[PAGEHIDE] First image before clear:', {
        src: img.src?.substring(0, 100),
        srcset: img.srcset?.substring(0, 50),
        dataSrc: img.getAttribute('data-src')?.substring(0, 50),
        classes: img.className
      });
    }
    // Clear the actual src attribute
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    img.removeAttribute('srcset');
    img.removeAttribute('data-srcset');
    img.removeAttribute('data-src');
    img.removeAttribute('data-widths');
    img.removeAttribute('data-sizes');
    // Clear lazysizes internal state by removing data-media-id which links to cached data
    img.removeAttribute('data-media-id');
    // Remove ALL lazy loading related classes (both theme and lazysizes standard)
    img.classList.remove('lazyloaded', 'lazyload', 'Image--lazyLoad', 'Image--fadeIn', 'lazyloading');
    // Mark as loaded to prevent lazysizes from trying to reload
    img.classList.add('lazyloaded');
  });
  
  console.log('[PAGEHIDE] Images cleared, body classes:', document.body.className);
});

window.addEventListener('pageshow', function(event) {
  const navType = performance.getEntriesByType?.('navigation')[0]?.type || 'unknown';
  
  console.log('%c[PAGESHOW EVENT]', 'background: #0a0; color: #fff; font-weight: bold;', {
    persisted: event.persisted,
    navigationType: navType,
    timestamp: new Date().toISOString(),
    bodyClasses: document.body.className
  });
  
  // Check first image state on pageshow
  const firstImg = document.querySelector('.ProductItem__Image, .ProductItem img');
  if (firstImg) {
    console.log('[PAGESHOW] First image state:', {
      src: firstImg.src?.substring(0, 100),
      srcset: firstImg.srcset?.substring(0, 50),
      dataSrc: firstImg.getAttribute('data-src')?.substring(0, 50),
      classes: firstImg.className
    });
  }
  
  if (event.persisted) {
    wasRestoredFromBfcache = true;
    console.log('%c[BFCACHE RESTORE DETECTED]', 'background: #f0f; color: #fff; font-weight: bold;');
    
    // Ensure body class is present (should persist, but be safe)
    document.body.classList.add('bfcache-loading');
    
    // Ensure spinner overlay is shown and products are hidden
    const overlay = document.querySelector('.spinner-overlay');
    const productList = document.querySelector('.ProductListWrapper');
    
    if (overlay) {
      overlay.classList.add('show');
    }
    if (productList) {
      productList.style.visibility = 'hidden';
      productList.style.opacity = '0';
    }
    
    // Clear ALL cached images immediately to prevent flash
    document.querySelectorAll('.ProductItem__Image, .ProductItem img, .ProductList img').forEach(function(img) {
      img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
      img.removeAttribute('srcset');
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-src');
      img.removeAttribute('data-widths');
      img.removeAttribute('data-sizes');
      img.removeAttribute('data-media-id');
      img.classList.remove('lazyloaded', 'lazyload', 'Image--lazyLoad', 'Image--fadeIn', 'lazyloading');
      img.classList.add('lazyloaded');
    });
  } else if (navType === 'back_forward') {
    // This is a back/forward navigation but NOT from bfcache
    // This means the page is being reloaded from HTTP cache
    console.log('%c[BACK/FORWARD WITHOUT BFCACHE]', 'background: #f90; color: #000; font-weight: bold;', 
      'This is likely the issue - page reloaded from HTTP cache, not bfcache');
    
    // Show loading state - the CSS will show the spinner overlay
    document.body.classList.add('bfcache-loading');
    const overlay = document.querySelector('.spinner-overlay');
    if (overlay) {
      overlay.classList.add('show');
    }
  } else {
    // Normal page load - ensure loading state is removed
    console.log('[PAGESHOW] Normal navigation, removing loading state');
    document.body.classList.remove('bfcache-loading');
  }
});

// Get collection handle using configuration function
const handle = getCollectionHandle();
fetchAllProducts(handle).then((ps) => {
  
  // Sort products by price (highest to lowest)
  all_products = (ps || []).sort((a, b) => {
    const priceA = parseFloat(a.priceRange?.minVariantPrice?.amount || 0);
    const priceB = parseFloat(b.priceRange?.minVariantPrice?.amount || 0);
    return priceB - priceA; // Descending order (highest first)
  });
  
  // Always start fresh - ensure empty state is hidden and products are shown
  document.querySelector(".filter-empty-state")?.style.setProperty("display", "none");
  document.querySelector(".ProductListWrapper")?.style.setProperty("display", "");
  document.querySelector(".Pagination")?.style.setProperty("display", "");
  
  // Check URL page parameter and validate/render initial page
  const urlParams = new URLSearchParams(window.location.search);
  const urlPage = parseInt(urlParams.get('page')) || 1;
  const totalPages = Math.ceil(all_products.length / PRODUCTS_PER_PAGE) || 1;
  
  
  // Cap page to valid range
  currentPage = Math.min(urlPage, totalPages);
  currentPage = Math.max(currentPage, 1);
  
  // If URL had invalid page, correct it
  if (urlPage !== currentPage) {
    const url = new URL(window.location);
    if (currentPage === 1) {
      url.searchParams.delete('page');
    } else {
      url.searchParams.set('page', currentPage);
    }
    history.replaceState({ page: currentPage }, '', url);
  }
}).catch((err) => {
  console.error('Error fetching products:', err);
});

const materalfilters = {
  "White Gold": [
    "10k White Gold",
    "14k White Gold",
    "18k White Gold",
    "19k White Gold",
    "10k White Gold / Rose Gold",
    "14k White Gold / Rose Gold",
    "10k Yellow Gold / White Gold",
    "14k Yellow Gold / White Gold",
    "18k Yellow Gold / White Gold",
    "10k White Gold / Yellow Gold",
    "14k White Gold / Yellow Gold",
    "14k Rose / White / Yellow Gold",
    "18k Rose / White / Yellow Gold",
    "Platinum / 10k White Gold",
    "Platinum / 14k White Gold",
    "Platinum / 18k White Gold",
    "Platinum / 18k Yellow Gold / 18k White Gold",
    "Platinum / 18k Yellow Gold / 18k White Gold / 18k Rose Gold",
    "18k White Gold / Black Gold",
    "14k White Gold / 18k White Gold",
    "18k White Gold / Sterling Silver",
    "18k White Gold / Stainless Steel",
    "18k White Gold / Rose Gold",
    "22K White Gold / Sterling Silver",
    "14K White Gold / Sterling Silver",
    "18k White Gold / 18k Yellow Gold / 18k Rose Gold / Sterling Silver",
    "18K Oxidized Gold",
    "Titanium / 14K White Gold",
    "10K Oxidized Gold",
  ],
  "Yellow Gold": [
    "9k Yellow Gold",
    "10k Yellow Gold",
    "12k Yellow Gold",
    "14k Yellow Gold",
    "18k Yellow Gold",
    "19k Yellow Gold",
    "20k Yellow Gold",
    "21k Yellow Gold",
    "22k Yellow Gold",
    "23k Yellow Gold",
    "24k Yellow Gold",
    "10k Yellow Gold / White Gold",
    "14k Yellow Gold / White Gold",
    "18k Yellow Gold / White Gold",
    "10k White Gold / Yellow Gold",
    "14k White Gold / Yellow Gold",
    "18k Yellow Gold / Rose Gold",
    "14k Yellow Gold / Silver",
    "18k Yellow Gold / Silver",
    "14k Rose / White / Yellow Gold",
    "14k Yellow Gold / Stainless Steel",
    "18k Rose / White / Yellow Gold",
    "18k Yellow Gold / Rhodium Coated",
    "Titanium / 18k Yellow Gold",
    "22k Yellow Gold / Sterling Silver",
    "18k Yellow Gold / Sterling Silver",
    "14k Yellow Gold / Sterling Silver",
    "Platinum / 18k Yellow Gold",
    "Platinum / 14k Yellow Gold",
    "Platinum / 18k Yellow Gold / 18k White Gold",
    "Platinum / 18k Yellow Gold / 18k White Gold / 18k Rose Gold",
    "18k Yellow Gold / 14k Yellow Gold",
    "22k Yellow Gold / 14k Yellow Gold",
    "18k Yellow Gold / 22k Yellow Gold",
    "18k Yellow Gold / Platinum",
    "24K Yellow Gold / Oxidized Silver",
    "22K Yellow Gold / Oxidized Silver",
    "18K Yellow Gold / Mother of Pearl",
    "24K GOLD",
    "18K Yellow Gold / Blue Resin / Ruby",
    "18K Yellow Gold / Briarwood",
    "18k White Gold / 18k Yellow Gold / 18k Rose Gold / Sterling Silver",
    "18K Oxidized Gold",
    "24K Gold / Damascus Steel",
    "10K Oxidized Gold",
    "Enamel / 14K Yellow Gold",
  ],
  Platinum: [
    "Platinum / 10k White Gold",
    "Platinum / 14k White Gold",
    "Platinum / 18k White Gold",
    "Platinum / 18k Yellow Gold",
    "Platinum / 14k Yellow Gold",
    "Platinum / 18k Yellow Gold / 18k White Gold",
    "Platinum / 18k Yellow Gold / 18k White Gold / 18k Rose Gold",
    "Platinum",
    "Platinum / 18k Yellow Gold / 18k White Gold / 18k Rose Gold",
    "18k Yellow Gold / Platinum",
    "Platinum / 18k Yellow Gold / 18k White Gold / 18k Rose Gold",
    "Platinum and Stainless Steel",
    "Platinum / Rose Gold",
  ],
  "All Gold Types": [
    "9k Yellow Gold",
    "10k Yellow Gold",
    "12k Yellow Gold",
    "14k Yellow Gold",
    "18k Yellow Gold",
    "19k Yellow Gold",
    "20k Yellow Gold",
    "21k Yellow Gold",
    "22k Yellow Gold",
    "23k Yellow Gold",
    "24k Yellow Gold",
    "10k Yellow Gold / White Gold",
    "14k Yellow Gold / White Gold",
    "18k Yellow Gold / White Gold",
    "10k White Gold / Yellow Gold",
    "14k White Gold / Yellow Gold",
    "18k Yellow Gold / Rose Gold",
    "14k Yellow Gold / Silver",
    "18k Yellow Gold / Silver",
    "14k Rose / White / Yellow Gold",
    "14k Yellow Gold / Stainless Steel",
    "18k Rose / White / Yellow Gold",
    "18k Yellow Gold / Rhodium Coated",
    "Titanium / 18k Yellow Gold",
    "22k Yellow Gold / Sterling Silver",
    "18k Yellow Gold / Sterling Silver",
    "14k Yellow Gold / Sterling Silver",
    "Platinum / 18k Yellow Gold",
    "Platinum / 14k Yellow Gold",
    "Platinum / 18k Yellow Gold / 18k White Gold",
    "Platinum / 18k Yellow Gold / 18k White Gold / 18k Rose Gold",
    "18k Yellow Gold / 14k Yellow Gold",
    "22k Yellow Gold / 14k Yellow Gold",
    "18k Yellow Gold / 22k Yellow Gold",
    "18k Yellow Gold / Platinum",
    "24K Yellow Gold / Oxidized Silver",
    "22K Yellow Gold / Oxidized Silver",
    "18K Yellow Gold / Mother of Pearl",
    "24K GOLD",
    "18K Yellow Gold / Blue Resin / Ruby",
    "18K Yellow Gold / Briarwood",
    "18k White Gold / 18k Yellow Gold / 18k Rose Gold / Sterling Silver",
    "18K Oxidized Gold",
    "24K Gold / Damascus Steel",
    "10K Oxidized Gold",
    "Enamel / 14K Yellow Gold",
    "10k White Gold",
    "14k White Gold",
    "18k White Gold",
    "10k White Gold / Rose Gold",
    "14k White Gold / Rose Gold",
    "18k White Gold / Black Gold",
    "14k White Gold / 18k White Gold",
    "18k White Gold / Sterling Silver",
    "18k White Gold / Stainless Steel",
    "18k White Gold / Rose Gold",
    "22K White Gold / Sterling Silver",
    "14K White Gold / Sterling Silver",
    "Titanium / 14K White Gold",
    "10k Rose Gold",
    "14k Rose Gold",
    "18k Rose Gold",
    "20k Rose Gold",
    "Titanium / 18k Rose Gold",
    "18k Rose Gold / Sterling Silver",
    "18k Rose Gold / Stainless Steel",
    "Platinum / 10k White Gold",
    "Platinum / 14k White Gold",
    "Platinum / 18k White Gold",
    "Platinum / Rose Gold",
    "14k Black Gold",
    "18k Black Gold",
    "Tri-Tone",
    "Two-Tone",
  ],
  Gold: [
    "9k Yellow Gold",
    "10k Yellow Gold",
    "12k Yellow Gold",
    "14k Yellow Gold",
    "18k Yellow Gold",
    "19k Yellow Gold",
    "20k Yellow Gold",
    "21k Yellow Gold",
    "22k Yellow Gold",
    "23k Yellow Gold",
    "24k Yellow Gold",
    "10k White Gold",
    "14k White Gold",
    "18k White Gold",
    "19k White Gold",
    "10k Rose Gold",
    "14k Rose Gold",
    "18k Rose Gold",
    "20k Rose Gold",
    "14k Black Gold",
    "18k Black Gold",
    "10k White Gold / Rose Gold",
    "14k White Gold / Rose Gold",
    "18k White Gold / Rose Gold",
    "10k Yellow Gold / White Gold",
    "14k Yellow Gold / White Gold",
    "18k Yellow Gold / White Gold",
    "10k White Gold / Yellow Gold",
    "14k White Gold / Yellow Gold",
    "18k Yellow Gold / Rose Gold",
    "14k Yellow Gold / Silver",
    "18k Yellow Gold / Silver",
    "14k Rose / White / Yellow Gold",
    "14k Yellow Gold / Stainless Steel",
    "18k Rose / White / Yellow Gold",
    "Titanium / 18k Rose Gold",
    "Titanium / 18k Yellow Gold",
    "18k Rose Gold / Sterling Silver",
    "22k Yellow Gold / Sterling Silver",
    "18k Yellow Gold / Sterling Silver",
    "14k Yellow Gold / Sterling Silver",
    "Sterling Silver",
    "Platinum / 10k White Gold",
    "Platinum / 18k White Gold",
    "Platinum / 14k Yellow Gold",
    "Platinum / 18k Yellow Gold / 18k White Gold / 18k Rose Gold",
    "18k White Gold / Black Gold",
    "14k White Gold / 18k White Gold",
    "18k Yellow Gold / 14k Yellow Gold",
    "22k Yellow Gold / 14k Yellow Gold",
    "18k Yellow Gold / 22k Yellow Gold",
    "18k Yellow Gold / Platinum",
    "18k White Gold / Sterling Silver",
    "14k Yellow Gold / Stainless Steel",
    "Tantalum/Steel",
    "24k Gold",
    "24k Yellow Gold / Oxidized Silver",
    "22K White Gold / Sterling Silver",
    "18K Yellow Gold / Mother of Pearl",
    "14K White Gold / Sterling Silver",
    "18k Yellow Gold / Blue Resin / Ruby",
    "18k Yellow Gold / Briarwood",
    "18K Oxidized Gold",
    "18k White Gold / 18k Yellow Gold / 18k Rose Gold / Sterling Silver",
    "Titanium / 14K White Gold",
    "24K Gold / Damascus Steel",
    "22k Yellow Gold / White Gold",
    "10K Oxidized Gold",
    "Platinum / 18K Rose Gold",
    "Enamel / 14K Yellow Gold",
  ],
  Others: [
    "14k Yellow Gold / Stainless Steel",
    "Gold Toned Steel",
    "Stainless Steel/Sterling Silver",
    "Stainless Steel",
    "18k Rose Gold / Stainless Steel",
    "18k White Gold / Stainless Steel",
    "Tantalum/Steel",
    "Damascus Steel",
    "Stainless Steel and Titanium",
    "Gold Plated Stainless Steel",
    "Titanium and Damascus Steel",
    "Sterling silver and Damascus steel",
    "Titanium and Elmax steel",
    "Stainless Steel and Damascus Steel",
    "Stainless Steel / Sterling Silver / Carbon Fiber",
    "Aluminium / Stainless Steel",
    "Titanium / Sterling Silver / Damascus Steel",
    "24K Gold / Damascus Steel",
    "Titanium / Maple Burl / Damascus Steel",
    "14k Yellow Gold / Silver",
    "18k Yellow Gold / Silver",
    "Sterling Silver",
    "18k White Gold / Sterling Silver",
    "14k Yellow Gold / Sterling Silver",
    "18k Rose Gold / Sterling Silver",
    "22k Yellow Gold / Sterling Silver",
    "24K Yellow Gold / Oxidized Silver",
    "Oxidized Sterling Silver",
    "Enamel / Sterling Silver",
    "14K White Gold / Sterling Silver",
    "18k White Gold / 18k Yellow Gold / 18k Rose Gold / Sterling Silver",
    "Titanium / 18k Rose Gold",
    "Titanium / 18k Yellow Gold",
    "18k Yellow Gold / Rhodium Coated",
    "14k Black Gold",
    "18k Black Gold",
    "Titanium / Tantalum",
    "Tantalum / Bronze",
    "Tantalum / Carbon Fiber",
    "Carbon / Titanium",
    "Mokume",
    "Other",
    "Jade",
    "Horn",
    "White Alligator",
    "Acrylic",
    "Base Metal",
    "Ceratanium",
    "Resin",
    "Lucite",
    "Crystal",
    "Carbon Fiber",
    "Cobalt",
    "Bronze",
    "Tungsten",
    "Ceramic",
    "Palladium",
    "Enamel",
    "Black Aluminum",
    "DLC",
    "PVD",
    "Polymer",
    "Aluminum",
    "18k White Gold / Black Gold",
    "Sapphire",
    "18K Yellow Gold / Mother of Pearl",
    "18K Yellow Gold / Blue Resin / Ruby",
    "18K Yellow Gold / Briarwood",
    "Enamel / 14K Yellow Gold",
    "Enamel / 14K White Gold",
  ],
};

const watchMaterialFitlers = {
  "Stainless Steel": [
    "14k Yellow Gold / Stainless Steel",
    "Gold Toned Steel",
    "Stainless Steel/Sterling Silver",
    "Stainless Steel",
    "18k Rose Gold / Stainless Steel",
    "18k White Gold / Stainless Steel",
    "14k Yellow Gold / Stainless Steel",
    "Tantalum/Steel",
    "Platinum and Stainless Steel",
    "Damascus Steel",
    "Stainless Steel and Titanium",
    "Gold Plated Stainless Steel",
    "Titanium and Damascus Steel",
    "Sterling Silver and Damascus Steel",
    "Titanium and Elmax Steel",
    "Stainless Steel and Damascus Steel",
    "Stainless Steel / Sterling Silver / Carbon Fiber",
    "Aluminium / Stainless Steel",
    "Titanium / Sterling Silver / Damascus Steel",
    "24K Gold / Damascus Steel",
    "Titanium / Maple Burl / Damascus Steel",
  ],
  Gold: [
    "9k Yellow Gold",
    "10k Yellow Gold",
    "12k Yellow Gold",
    "14k Yellow Gold",
    "18k Yellow Gold",
    "19k Yellow Gold",
    "20k Yellow Gold",
    "21k Yellow Gold",
    "22k Yellow Gold",
    "23k Yellow Gold",
    "24k Yellow Gold",
    "10k White Gold",
    "14k White Gold",
    "18k White Gold",
    "19k White Gold",
    "10k Rose Gold",
    "14k Rose Gold",
    "18k Rose Gold",
    "20k Rose Gold",
    "14k Black Gold",
    "18k Black Gold",
    "10k White Gold / Rose Gold",
    "14k White Gold / Rose Gold",
    "18k White Gold / Rose Gold",
    "10k Yellow Gold / White Gold",
    "14k Yellow Gold / White Gold",
    "18k Yellow Gold / White Gold",
    "10k White Gold / Yellow Gold",
    "14k White Gold / Yellow Gold",
    "18k Yellow Gold / Rose Gold",
    "14k Yellow Gold / Silver",
    "18k Yellow Gold / Silver",
    "14k Rose / White / Yellow Gold",
    "14k Yellow Gold / Stainless Steel",
    "18k Rose / White / Yellow Gold",
    "Titanium / 18k Rose Gold",
    "Titanium / 18k Yellow Gold",
    "18k Rose Gold / Sterling Silver",
    "22k Yellow Gold / Sterling Silver",
    "18k Yellow Gold / Sterling Silver",
    "14k Yellow Gold / Sterling Silver",
    "Sterling Silver",
    "Platinum / 10k White Gold",
    "Platinum / 18k White Gold",
    "Platinum / 14k Yellow Gold",
    "Platinum / 18k Yellow Gold / 18k White Gold / 18k Rose Gold",
    "18k White Gold / Black Gold",
    "14k White Gold / 18k White Gold",
    "18k Yellow Gold / 14k Yellow Gold",
    "22k Yellow Gold / 14k Yellow Gold",
    "18k Yellow Gold / 22k Yellow Gold",
    "18k Yellow Gold / Platinum",
    "18k White Gold / Sterling Silver",
    "14k Yellow Gold / Stainless Steel",
    "Tantalum/Steel",
    "24k Gold",
    "24k Yellow Gold / Oxidized Silver",
    "22k White Gold / Sterling Silver",
    "18k Yellow Gold / Mother of Pearl",
    "14k White Gold / Sterling Silver",
    "18k Yellow Gold / Blue Resin / Ruby",
    "18k Yellow Gold / Briarwood",
    "18k Oxidized Gold",
    "18k White Gold / 18k Yellow Gold / 18k Rose Gold / Sterling Silver",
    "Titanium / 14k White Gold",
    "24k Gold / Damascus Steel",
    "22k Yellow Gold / White Gold",
    "10k Oxidized Gold",
    "Platinum / 18K Rose Gold",
    "Enamel / 14k Yellow Gold",
  ],
  Titanium: [
    "Titanium / 18k Rose Gold",
    "Titanium / 18k Yellow Gold",
    "Titanium",
    "Stainless Steel and Titanium",
    "Titanium and Damascus Steel",
    "Titanium and Elmax Steel",
    "Titanium / Tantalum",
    "Titanium / Sterling Silver / Damascus Steel",
    "24k Gold / Damascus Steel",
    "Titanium / Maple Burl / Damascus Steel",
  ],
  Ceramic: ["Ceramic"],
  Mixed: [
    "14k Yellow Gold / Stainless Steel",
    "18k Yellow Gold / Rhodium Coated",
    "Stainless Steel/Sterling Silver",
    "Titanium / 18k Rose Gold",
    "Titanium / 18k Yellow Gold",
    "18k Rose Gold / Sterling Silver",
    "22k Yellow Gold / Sterling Silver",
    "18k Yellow Gold / Sterling Silver",
    "14k Yellow Gold / Sterling Silver",
    "Platinum / 10k White Gold",
    "Platinum / 14k White Gold",
    "Platinum / 18k White Gold",
    "Platinum / 14k Yellow Gold",
    "Platinum / 18k Yellow Gold",
    "Platinum / 18k Yellow Gold / 18k White Gold",
    "Platinum / 18k Yellow Gold / 18k White Gold / 18k Rose Gold",
    "18k White Gold / Sterling Silver",
    "Platinum and Stainless Steel",
    "Stainless Steel and Titanium",
    "24k Yellow Gold / Oxidized Silver",
    "Titanium and Damascus Steel",
    "Sterling Silver and Damascus Steel",
    "Titanium and Elmax Steel",
    "Stainless Steel and Damascus Steel",
    "Stainless Steel / Sterling Silver / Carbon Fiber",
    "22k Yellow Gold / Oxidized Silver",
    "22k White Gold / Sterling Silver",
    "Enamel / Sterling Silver",
    "22k White Gold / Sterling Silver",
    "18k Yellow Gold / Mother of Pearl",
    "14k White Gold / Sterling Silver",
    "18k Yellow Gold / Blue Resin / Ruby",
    "18k Yellow Gold / Briarwood",
    "18k Oxidized Gold",
    "18k White Gold / 18k Yellow Gold / 18k Rose Gold / Sterling Silver",
    "Titanium / Tantalum",
    "Tantalum / Bronze",
    "Tantalum / Carbon Fiber",
    "Titanium / 14k White Gold",
    "Carbon / Titanium",
    "Aluminium / Stainless Steel",
    "Titanium / Sterling Silver / Damascus Steel",
    "Platinum / 18k Rose Gold",
    "Enamel / 14k Yellow Gold",
  ],
  Other: [
    "Other",
    "Jade",
    "Horn",
    "White Alligator",
    "Acrylic",
    "Base Metal",
    "Ceratanium",
    "Resin",
    "Lucite",
    "Crystal",
    "Carbon Fiber",
    "Cobalt",
    "Bronze",
    "Tri-Tone",
    "Two-Tone",
    "Tungsten",
    "Palladium",
    "Enamel",
    "Black Aluminum",
    "DLC",
    "PVD",
    "Polymer",
    "Aluminum",
    "Carbon",
    "Sapphire",
    "Oxidized Sterling Silver",
    "Tantalum",
    "Mokume",
  ],
};

const stoneMisspellings = {
  diamond: ["diamond", "diamonds", "diamon", "diamand", "dimaond"],
  amethyst: ["amethyst", "amethysts", "amathyst", "amathist", "amethyst"],
  aquamarine: ["aquamarine", "aquamarines", "aquamarinne", "aquamarain", "aqumarine"],
  beryl: ["beryl", "beryls", "beryll", "beril", "berly"],
  citrine: ["citrine", "citrines", "citrin", "citrene", "citrine"],
  emerald: ["emerald", "emeralds", "emeral", "emrald", "emereld"],
  garnet: ["garnet", "garnets", "garnett", "garent", "garnet"],
  jade: ["jade", "jades", "jaed", "jadee", "jaid"],
  moissanite: ["moissanite", "moissanites", "moissanite", "moissanite"],
  onyx: ["onyx", "onyxes", "onix", "onyxs", "onix"],
  opal: ["opal", "opals", "opell", "opaal", "opl"],
  "pearl (inclues freshwater pearl)": ["pearl", "pearls", "pearll", "peral", "perl"],
  peridot: ["peridot", "peridots", "peridote", "peridot", "perdote"],
  ruby: ["ruby", "rubies", "rubby", "rubi", "rubey"],
  sapphire: ["sapphire", "sapphires", "saphire", "sapphire", "saphirre"],
  spinel: ["spinel", "spinels", "spinal", "spinell", "spinnel"],
  tanzanite: ["tanzanite", "tanzanites", "tanzinite", "tanzanit", "tanzanitte"],
  topaz: ["topaz", "topazes", "topazz", "topas", "topaz"],
  tourmaline: ["tourmaline", "tourmalines", "tourmaline", "tourmalin", "tourmalene"],
  turquoise: ["turquoise", "turquoises", "turqouise", "turquise", "turqouise"],
  alexandrite: ["alexandrite", "alexandrites", "alexndrite", "alexandrit", "alexzandrite"],
  agate: ["agate", "agates", "agatte", "agat", "agate"],
  abalone: ["abalone", "abalones", "abalone", "abalonie", "abalonee"],
  chrysoprase: ["chrysoprase", "chrysoprases", "chrysophrase", "chrysoprase", "chrysopraze"],
  crystal: ["crystal", "crystals", "crystle", "crystial", "cristal"],
  "dinosaur bone": ["dinosaur bone", "dinosaur bones", "dinosour bone", "dinosaur bon", "dinosaur bones"],
  hematite: ["hematite", "hematites", "hematitt", "hemetite", "hematite"],
  kirinite: ["kirinite", "kirinites", "kirinite", "kirinite", "kirenite"],
  lava: ["lava", "lavas", "lavaa", "lave", "lavaa"],
  "mammoth tooth": ["mammoth tooth", "mammoth teeth", "mammoth toothes", "mammoth teath"],
  "mother of pearl": ["mother of pearl", "mothers of pearl", "mothr of pearl", "mother of pearle"],
  multi: ["multi", "multis", "multie", "multis", "muliti"],
  "oregon sunstone": ["oregon sunstone", "oregon sunstones", "oregan sunstone", "oregon sunstones"],
  "oyster shell": ["oyster shell", "oyster shells", "oysther shell", "oystar shell"],
  sugilite: ["sugilite", "sugilites", "sugillite", "sugelite", "sugilitte"],
  "tiger's eye": ["tiger's eye", "tiger's eyes", "tigers eye", "tiger's eyes", "tiger eye"],
  unakite: ["unakite", "unakites", "unkite", "unakitte", "unikite"],
  meteorite: ["meteorite", "meteorites", "meteoritte", "metiorite"],
  charoite: ["charoite", "charoites", "charoitte", "charorite"],
  ametrine: ["ametrine", "ametrines", "ametrin", "ametrrine", "ametrine"],
  ammolite: ["ammolite", "ammolites", "ammolitt", "ammolit"],
  bloodstone: ["bloodstone", "bloodstones", "bloodstoe", "bloodston"],
  carnelian: ["carnelian", "carnelians", "carenlian", "carnelian"],
  "cat's eye": ["cat's eye", "cat's eyes", "cats eye", "cat's eyes", "cats eyes"],
  chalcedony: ["chalcedony", "chalcedonies", "chalcedony", "chalcedony", "chalcedony"],
  chrysoberyl: ["chrysoberyl", "chrysoberyls", "chrysoberyll", "chrysobery", "chrysbeyrl"],
  "chrome diopside": ["chrome diopside", "chrome diopsides", "chrome dipside", "chrom diopside"],
  coral: ["coral", "corals", "corral", "coral", "corral"],
  "cubic zirconia": ["cubic zirconia", "cubic zirconias", "cubic ziconia", "cubic zirconia"],
  iolite: ["iolite", "iolites", "iolitte", "iolight"],
  jasper: ["jasper", "jaspers", "jaspar", "jaspper"],
  kunzite: ["kunzite", "kunzites", "kunizite", "kunzitt"],
  labradorite: ["labradorite", "labradorites", "labradoritte", "labradorit"],
  lapis: ["lapis", "lapis", "lapis", "lapiz"],
  malachite: ["malachite", "malachites", "malachitte", "malachit"],
  moldavite: ["moldavite", "moldavites", "moldavitte", "moldavite"],
  moonstone: ["moonstone", "moonstones", "moonstoe", "moonston"],
  morganite: ["morganite", "morganites", "morgante", "morganiite"],
  prasiolite: ["prasiolite", "prasiolites", "prasiolitt", "prasiolite"],
  quartz: ["quartz", "quartz", "quarts", "quartze"],
  rhodochrosite: ["rhodochrosite", "rhodochrosites", "rhodochrositte", "rhodochrose"],
  rhodonite: ["rhodonite", "rhodonites", "rhodonitte", "rhodinite"],
  serpentine: ["serpentine", "serpentines", "serpentine", "serpintine"],
  sunstone: ["sunstone", "sunstones", "sunstoe", "sunstone"],
  tsavorite: ["tsavorite", "tsavorites", "tsavorite", "tsavorite"],
  zircon: ["zircon", "zircons", "zircon", "zircon"],
  obsidian: ["obsidian", "obsidian", "obsidian", "obsidian"],
  "kashmir blue": ["kashmir blue", "kashmir blues", "kashmir blue", "kashmir blue"],
  sodalite: ["sodalite", "sodalites", "sodalite", "sodalite"],
};

const stoneFilters = {
  "All Others": [
    "Agate",
    "Abalone",
    "Agate",
    "Chrysoprase",
    "Crystal",
    "Dinosaur bone",
    "Hematite",
    "Kirinite",
    "Lava",
    "Mammoth tooth",
    "Mother of pearl",
    "Multi-stone",
    "Oregon sunstone",
    "Oyster shell",
    "Sugilite",
    "Tiger's eye",
    "Unakite",
    "Meteorite",
    "Charoite",
    "Ametrine",
    "Ammolite",
    "Bloodstone",
    "Carnelian",
    "Cat's eye",
    "Chalcedony",
    "Chrysoberyl",
    "Chrome diopside",
    "Coral",
    "Cubic zirconia",
    "Iolite",
    "Jasper",
    "Kunzite",
    "Labradorite",
    "Lapis",
    "Malachite",
    "Moldavite",
    "Moonstone",
    "Morganite",
    "Prasiolite",
    "Quartz",
    "Rhodochrosite",
    "Rhodonite",
    "Serpentine",
    "Sunstone",
    "Tsavorite",
    "Zircon",
    "Obsidian",
    "Kashmir blue",
    "Sodalite",
  ],
  Colored: [
    "Amethyst",
    "Aquamarine",
    "Beryl",
    "Citrine",
    "Emerald",
    "Garnet",
    "Jade",
    "Moissanite",
    "Onyx",
    "Opal",
    "Pearl",
    "Peridot",
    "Ruby",
    "Sapphire",
    "Spinel",
    "Tanzanite",
    "Topaz",
    "Tourmaline",
    "Turquoise",
    "Alexandrite",
  ],
};

const coloredGemstones = [...stoneFilters["Colored"], ...stoneFilters["All Others"]];

const diamondColorFitlers = {
  "D-F": ["D", "E", "F", "D-E", "D-F", "E-F"],
  "G-J": ["G", "H", "I", "J", "G-H", "G-I", "G-J", "H-I", "H-J", "I-J", "G-I-J", "G-H-I-J"],
  "K+": ["K", "L", "M", "N", "O", "P", "K-L", "K-M", "K-N", "K-O", "K-P", "L-M", "L-N", "L-O", "L-P", "M-N", "M-O", "M-P", "N-O", "N-P", "O-P"],
  Fancy: [
    "Blue",
    "Ceylon",
    "Deep Royal Blue",
    "Fancy Colored",
    "Fancy Green Yellow",
    "Fancy Light Yellow",
    "Fancy Yellow",
    "Galaxy",
    "Grape",
    "Highly Saturated Deep Kelly Green",
    "Intense Ideal Kelly Green",
    "Intense Fancy Yellow",
    "Kelly Green",
    "London Blue",
    "Natural Pink",
    "Salmon",
    "Shamrock",
    "Tahitian",
    "Santa Maria",
    "Yellow",
    "Fancy Brown Yellow",
    "Irradiated Blue",
    "Red",
    "Light Yellow",
    "White",
  ],
  Brown: ["L-Brown", "TLB", "Brown", "Champagne", "Cognac", "Chocolate", "Fancy Light Brownish Yellow"],
  Black: ["Black"],
};

const diamondClarityFilters = {
  IF: ["IF"],
  VVS: ["VVS1", "VVS2", "VVS", "VVS1-VVS2", "Varies (VS-VVS)", "AAA+"],
  VS: ["VS1", "VS2", "VS", "VS1-VS2", "Varies (SI-VS)", "AAA", "VS2-I1"],
  SI: ["SI1", "SI2", "SI3", "SI", "SI1-SI2", "SI2-SI3", "Varies (I-SI)", "AA", "I-SI"],
  I: ["I1", "I2", "I3", "I1-I2", "I2-I1", "SI3-I1", "SI3-I1", "I-SI"],
};

// Fuzzy matching for house/non-designer vendor names
// Matches variations of:
//   - "Estate Watch And Jewelry Company", "The Estate Watch And Jewelry Company®", "The Estate Watch & Jewelry Co."
//   - "E.D. Marshall Jewelers™", "ED Marshall", "E.D. Marshall", "EDM"
const isEstateWatchVendor = (vendor) => {
  if (!vendor || typeof vendor !== 'string') {
    return false;
  }
  const vendorLower = vendor.toLowerCase();
  
  // Check for "Estate Watch And Jewelry" variations
  // Must contain "estate" and "watch" and "jewelry" (core identifying words)
  const hasEstate = vendorLower.includes('estate');
  const hasWatch = vendorLower.includes('watch');
  const hasJewelry = vendorLower.includes('jewelry') || vendorLower.includes('jewellery');
  const isEstateWatch = hasEstate && hasWatch && hasJewelry;
  
  // Check for "E.D. Marshall" / "ED Marshall" variations
  // Normalize: remove periods and spaces to catch "E.D. Marshall", "ED Marshall", "E.D.Marshall", etc.
  const vendorNormalized = vendorLower.replace(/\./g, '').replace(/\s+/g, '');
  const isEDMarshall = vendorNormalized.includes('edmarshall') || vendorNormalized === 'edm';
  
  return isEstateWatch || isEDMarshall;
};

const stoneMatches = (text, stoneToMatch) => {
  if (!text || !stoneToMatch) {
    return false;
  }

  const textLower = text.toLowerCase();
  const stoneVariationsToMatch = [stoneToMatch.toLowerCase(), ...(stoneMisspellings[stoneToMatch.toLowerCase()] || [])];

  // For gemstones that are also cut names (like Emerald), use strict pattern matching
  const cutStyleGemstones = ['emerald', 'marquise', 'pear', 'oval', 'cushion', 'radiant', 'princess', 'heart', 'asscher'];
  
  // Debug logging for emerald matching
  const shouldDebug = stoneToMatch.toLowerCase() === 'emerald' && textLower.includes('emerald');
  
  return stoneVariationsToMatch.some((variation) => {
    // Use word boundary matching to avoid substring false positives
    // e.g., "emeral" (misspelling) should not match inside "emerald cut"
    const variationWordPattern = new RegExp(`\\b${variation}\\b`, 'i');
    if (!variationWordPattern.test(textLower)) {
      return false;
    }
    
    // For misspellings of cut-style gems, apply the same cut-style detection
    // Check if this variation is a misspelling of a cut-style gemstone
    const isMisspellingOfCutStyleGem = cutStyleGemstones.some(cutGem => {
      const misspellings = stoneMisspellings[cutGem] || [];
      return misspellings.includes(variation) || variation === cutGem;
    });
    
    // If this is a cut-style gemstone name OR a misspelling of one, require specific patterns that prove it's an actual stone
    if (isMisspellingOfCutStyleGem) {
      // Find the base cut-style gem that this variation belongs to
      const baseCutStyleGem = cutStyleGemstones.find(cutGem => {
        const misspellings = stoneMisspellings[cutGem] || [];
        return misspellings.includes(variation) || variation === cutGem;
      }) || variation;
      
      // First check: if "cut" appears right after the gem name (or its misspellings), it's definitely a cut style, not actual stone
      // Check for both the base gem name and all its variations
      const allVariationsForCutCheck = [baseCutStyleGem, ...(stoneMisspellings[baseCutStyleGem] || [])];
      const cutStylePattern = new RegExp(`(${allVariationsForCutCheck.join('|')})\\s*(cut|center|diamond|shape|-cut)`, 'i');
      const isCutStyle = cutStylePattern.test(textLower);
      
      // Debug for emerald
      const isEmeraldDebug = baseCutStyleGem === 'emerald' && textLower.includes('emerald');
      if (isEmeraldDebug) {
        console.log('%c[stoneMatches - EMERALD]', 'background: #808; color: #fff;', {
          textSnippet: textLower.substring(0, 80),
          isCutStyle,
          cutStylePattern: cutStylePattern.toString()
        });
      }
      
      if (isCutStyle) {
        // It's a cut style - but check if there's ALSO an actual stone reference elsewhere
        // e.g., "6.20CT Fine Quality Colombian Emerald and 1.82CTW Diamond Ring"
        // This has both "emerald" as actual stone AND might have other cut references
        
        // Use all variations of the gem name for pattern matching
        const gemVariationsPattern = `(${allVariationsForCutCheck.join('|')})`;
        
        // Stronger patterns that definitively indicate an actual stone
        // IMPORTANT: Use \b (word boundary) after gem name to prevent partial matches like "emeral" matching inside "emerald"
        const definitiveStonePatterns = [
          // "colombian emerald", "natural emerald", "genuine emerald"
          new RegExp(`(colombian|natural|genuine|certified|real|fine quality)\\s+${gemVariationsPattern}\\b(?!\\s*(cut|center|diamond|shape|-cut))`, 'i'),
          // "X.XXct emerald" where emerald is NOT followed by cut
          new RegExp(`\\d+(\\.\\d+)?\\s*(ct|carat|ctw|cttw)\\s+${gemVariationsPattern}\\b(?!\\s*(cut|center|diamond|shape|-cut))`, 'i'),
          // "emerald and diamond" where emerald starts a phrase (actual stone paired with other stone)
          new RegExp(`${gemVariationsPattern}\\b\\s+(and|&)\\s+(diamond|\\d)`, 'i'),
        ];
        
        const hasDefinitiveStone = definitiveStonePatterns.some(p => p.test(textLower));
        
        // Debug for emerald
        if (isEmeraldDebug) {
          console.log('%c[stoneMatches - EMERALD CUT STYLE PATH]', 'background: #f0f; color: #000;', {
            hasDefinitiveStone,
            patternResults: definitiveStonePatterns.map((pat, i) => ({
              pattern: i === 0 ? 'colombian/natural/etc' : i === 1 ? 'X.XXct emerald' : 'emerald and diamond',
              matches: pat.test(textLower)
            }))
          });
        }
        
        return hasDefinitiveStone;
      }
      
      // No cut style pattern found - check for actual stone patterns
      // Use all variations of the gem name for pattern matching
      // IMPORTANT: Use \b (word boundary) after gem name to prevent partial matches like "emeral" matching inside "emerald"
      const gemVariationsPatternForActual = `(${allVariationsForCutCheck.join('|')})`;
      
      const actualStonePatterns = [
        // "colombian emerald", "natural emerald", "genuine emerald", "certified emerald"
        new RegExp(`(colombian|natural|genuine|certified|real)\\s+${gemVariationsPatternForActual}\\b`, 'i'),
        // "emerald and diamond", "emerald & diamond", "emerald with diamond"
        new RegExp(`${gemVariationsPatternForActual}\\b\\s+(and|&|with)\\s+`, 'i'),
        // "diamond and emerald", "with emerald" - but NOT if followed by "cut"
        new RegExp(`(and|&|with)\\s+${gemVariationsPatternForActual}\\b(?!\\s*(cut|center|diamond|shape|-cut))`, 'i'),
        // "X.XXct emerald", "X.XX ct emerald", "X.XX carat emerald"
        new RegExp(`\\d+(\\.\\d+)?\\s*(ct|carat|ctw|cttw)\\s+${gemVariationsPatternForActual}\\b`, 'i'),
        // "emerald stone", "emerald gemstone"
        new RegExp(`${gemVariationsPatternForActual}\\b\\s+(stone|gemstone)`, 'i'),
        // "emerald ring", "emerald bracelet", "emerald necklace" - standalone product types
        new RegExp(`${gemVariationsPatternForActual}\\b\\s+(ring|bracelet|necklace|pendant|earring)s?\\b`, 'i'),
      ];
      
      // Check if any actual stone pattern matches
      const isActualStone = actualStonePatterns.some(pattern => pattern.test(textLower));
      
      if (isActualStone) {
        return true;
      }
      
      // If none of the actual stone patterns match, this is likely a cut style
      return false;
    }
    
    return true;
  });
};

const containsNoStones = (text) => {
  let containsStones = false;

  const gemstones = [...coloredGemstones, ...Object.keys(stoneMisspellings)];
  return stoneMatchesNone(text, gemstones);
};

const containsColoredGemstones = (text) => {
  if (!text) return false;
  
  const textLower = text.toLowerCase();
  
  // Cut-style gemstone names that can be confused with cut shapes
  const cutStyleGemstones = ['emerald', 'marquise', 'pear', 'oval', 'cushion', 'radiant', 'princess', 'heart', 'asscher'];
  
  // For each colored gemstone, check if it's in the text as an actual stone
  return coloredGemstones.some(gem => {
    const gemLower = gem.toLowerCase();
    
    // Check if the text contains this gem name at all
    if (!textLower.includes(gemLower)) {
      return false;
    }
    
    // If it's a cut-style gemstone name, use stoneMatches which has the cut-exclusion logic
    if (cutStyleGemstones.includes(gemLower)) {
      return stoneMatches(text, gem);
    }
    
    // For non-cut-style gems, use standard matching
    return stoneMatches(text, gem);
  });
};

const stoneIsColoredGemstone = (stone) => {
  if (!stone || typeof stone !== "string") {
    return false;
  }
  return coloredGemstones.some((coloredGemstone) => coloredGemstone.toLowerCase() === stone.toLowerCase());
};

const stoneMatchesAny = (text, stonesToMatch) => {
  if (!text || !stonesToMatch || !Array.isArray(stonesToMatch)) {
    return false;
  }

  return stonesToMatch.some((stone) => stoneMatches(text, stone));
};

const stoneMatchesNone = (text, stonesToMatch) => {
  if (!text || !stonesToMatch || !Array.isArray(stonesToMatch)) {
    return true; // If no text or stones to match, then it's true that none match
  }

  return !stonesToMatch.some((stone) => stoneMatches(text, stone));
};

// Check if jQuery is available, if not wait for it
function initializeFilterSystem() {
  if (typeof jQuery === 'undefined') {
    setTimeout(initializeFilterSystem, 100);
    return;
  }
  
  jQuery(document).ready(function ($) {
    const url = window.location.href;

  // Note: Button expand/collapse is handled by inline script in collection-filter.liquid
  // using CSS-based aria-expanded approach. Do not add duplicate handlers here.

  // ============================================
  // SYNC FILTERS BETWEEN DESKTOP AND MOBILE
  // Since filters are rendered twice (sidebar & drawer), we need to keep them in sync
  // ============================================
  
  /**
   * Sync checkbox state between desktop sidebar and mobile drawer
   * @param {Element} changedCheckbox - The checkbox that was just changed
   */
  function syncCheckboxState(changedCheckbox) {
    const $changed = $(changedCheckbox);
    const value = $changed.val();
    const isChecked = $changed.prop('checked');
    const filterType = $changed.closest('.custom-filter').data('filter');
    
    // Find matching checkbox in the other filter instance
    // Desktop is in .CollectionInner__Sidebar, Mobile is in .mobile-filters-container
    const isInMobile = $changed.closest('.mobile-filters-container').length > 0;
    const targetContainer = isInMobile ? '.CollectionInner__Sidebar' : '.mobile-filters-container';
    
    // Find the matching checkbox by filter type and value
    const $matchingCheckbox = $(targetContainer)
      .find(`.custom-filter[data-filter="${filterType}"] input[type="checkbox"][value="${value}"]`);
    
    if ($matchingCheckbox.length > 0 && $matchingCheckbox.prop('checked') !== isChecked) {
      $matchingCheckbox.prop('checked', isChecked);
      
      // Also sync visibility of sub-menus if applicable
      if ($changed.hasClass('has-submenu')) {
        const $sourceSubmenu = $changed.parent().next('.sub-menu');
        const $targetSubmenu = $matchingCheckbox.parent().next('.sub-menu');
        if (isChecked) {
          $targetSubmenu.show();
        } else {
          $targetSubmenu.hide();
          $targetSubmenu.find('input[type="checkbox"]').prop('checked', false);
        }
      }
    }
  }
  
  /**
   * Sync all unchecked states when a radio-like filter is selected
   * @param {string} selector - jQuery selector for the filter group
   * @param {Element} checkedEl - The element that was checked
   */
  function syncUncheckedStates(selector, checkedEl) {
    const $checked = $(checkedEl);
    const checkedValue = $checked.val();
    
    // For each checkbox that was unchecked (not the one that's checked), sync to other instance
    $(selector).not(checkedEl).each(function() {
      syncCheckboxState(this);
    });
  }
  
  /**
   * Update mobile filter badge count
   */
  function updateMobileFilterBadge() {
    const activeCount = Object.values(selectedFilters).reduce((count, arr) => {
      return count + (arr && arr.length > 0 ? 1 : 0);
    }, 0);
    
    const $filterBtn = $('.CollectionToolbar__Item--filter');
    let $badge = $filterBtn.find('.filter-count');
    
    if (activeCount > 0) {
      if ($badge.length === 0) {
        $filterBtn.append('<span class="filter-count">' + activeCount + '</span>');
      } else {
        $badge.text(activeCount);
      }
    } else {
      $badge.remove();
    }
  }
  
  // Initialize mobile drawer filters when it opens
  // The theme.js handles drawer open/close via data-action="open-drawer"
  // We just need to ensure the Collapsible__Inner elements are visible
  $(document).on('click', '.CollectionToolbar__Item--filter', function() {
    // Ensure mobile filter drawers are visible after a slight delay
    setTimeout(function() {
      $(".mobile-filters-container .Collapsible__Inner").css({
        "height": "auto",
        "visibility": "visible"
      });
      // Re-initialize filter indicators to ensure mobile filters have proper structure
      initFilterIndicators();
    }, 100);
  });

  $(priceSelector).change(function () {
    if (this.checked) {
      $(priceSelector).not(this).prop("checked", false);
      syncUncheckedStates(priceSelector, this);
    }
    syncCheckboxState(this);

    //$(this).parents(".dropdown").toggle();

    const values = $(this).val().split("~");
    showOverlay();

    if (this.checked) {
      selectedFilters["price"] = values.map((v) => parseInt(v));
    } else {
      selectedFilters["price"] = [];
    }
    applyFilter();
  });

  $(stonesFitlerSelector).change(function () {
    if (this.checked) {
      $(stonesFitlerSelector).not(this).prop("checked", false);
      $(subMenuSelector).prop("checked", false);
      syncUncheckedStates(stonesFitlerSelector, this);
    }
    syncCheckboxState(this);

    // Hide all sub-menus in this filter group when any option is selected
    $(this).closest('.custom-filter').find('.sub-menu').hide();
    // Clear any selected options in hidden sub-menus
    $(this).closest('.custom-filter').find('.sub-menu input[type="checkbox"]').prop('checked', false);
    
    if ($(this).hasClass("has-submenu")) {
      if (this.checked) {
        $(this).parent().next().show();
        if ($(this).val() === "Colored Gemstone") {
          showOverlay();
          selectedFilters["stones"] = ['Colored Gemstone'];
        }
      } else {
        $(this).parent().next().hide();
        showOverlay();
        selectedFilters["stones"] = [];
      }
      applyFilter();
      return;
    }

    //$(this).parents(".dropdown").toggle();

    showOverlay();

    if (this.checked) {
      selectedFilters["stones"] = [$(this).val()];
    } else {
      selectedFilters["stones"] = selectedFilters["stones"].filter((p) => p !== $(this).val());
    }

    applyFilter();
  });

  $(stonesDesignerFitlerSelector).change(function () {
    if (this.checked) {
      $(stonesDesignerFitlerSelector).not(this).prop("checked", false);
      syncUncheckedStates(stonesDesignerFitlerSelector, this);
    }
    syncCheckboxState(this);

    //$(this).parents(".dropdown").toggle();

    showOverlay();

    if (this.checked) {
      selectedFilters["stonesDesigner"] = stoneFilters[$(this).val()] || [$(this).val()];
    } else {
      selectedFilters["stonesDesigner"] = [];
    }
    applyFilter();
  });

  $(subMenuSelector).change(function () {
    var multiSelect = $(this).parents(".sub-menu").hasClass("multi-select");
    if (this.checked) {
      // Uncheck all other checkboxes
      if (!multiSelect) {
        $(subMenuSelector).not(this).prop("checked", false);
        syncUncheckedStates(subMenuSelector, this);
      }
    }
    syncCheckboxState(this);

    showOverlay();

    const filterVal = stoneFilters[$(this).val()] || [$(this).val()];

    if (this.checked) {
      if (multiSelect) {
        const checkedValues = $('input[name="gemstones"]:checked')
        if (checkedValues.length > 0) {
          var selectedValues = checkedValues
            .map(function () {
              return this.value;
            })
            .get();
          selectedFilters["stones"] = selectedValues;
        } else {
          selectedFilters["stones"] = filterVal;
        }
      } else selectedFilters["stones"] = filterVal;
    } else {
      const checkedValues = $('input[name="gemstones"]:checked')
      if (checkedValues.length > 0) {
        selectedFilters["stones"] = selectedFilters["stones"].filter((p) => !filterVal.includes(p));
      } else {
        selectedFilters["stones"] = ['Colored Gemstone'];
      }
    }
    applyFilter();
  });

  // Material Filter
  $(materialFitlerSelector).change(function () {
    if (this.checked) {
      // Uncheck all other checkboxes
      $(materialFitlerSelector).not(this).prop("checked", false);
      syncUncheckedStates(materialFitlerSelector, this);
    }
    syncCheckboxState(this);

    //$(this).parents(".dropdown").toggle();

    showOverlay();

    const filterVal = materalfilters[$(this).val()] || [$(this).val()];

    if (this.checked) {
      selectedFilters["material"] = filterVal;
    } else {
      selectedFilters["material"] = selectedFilters["material"].filter((p) => !filterVal.includes(p));
    }
    applyFilter();
  });
  // Material Filter
  // Material Type filter (for watches) - use delegation with .on()
  $(document).on('change', materialTypeSelector, function () {
    if (this.checked) {
      // Uncheck all other checkboxes
      $(materialTypeSelector).not(this).prop("checked", false);
      syncUncheckedStates(materialTypeSelector, this);
    }
    syncCheckboxState(this);

    //$(this).parents(".dropdown").toggle();

    showOverlay();

    // Use watchMaterialFitlers for watches Material Type filter
    const filterVal = watchMaterialFitlers[$(this).val()] || [$(this).val()];

    if (this.checked) {
      selectedFilters["materialType"] = filterVal;
    } else {
      selectedFilters["materialType"] = selectedFilters["materialType"].filter((p) => !filterVal.includes(p));
    }
    applyFilter();
  });
  // Material Band Filter
  $(materialBandsFitlerSelector).change(function () {
    if (this.checked) {
      // Uncheck all other checkboxes
      $(materialBandsFitlerSelector).not(this).prop("checked", false);
      syncUncheckedStates(materialBandsFitlerSelector, this);
    }
    syncCheckboxState(this);

    //$(this).parents(".dropdown").toggle();

    showOverlay();

    const filterVal = [$(this).val()];
    if (this.checked) {
      selectedFilters["material_band"] = filterVal;
    } else {
      selectedFilters["material_band"] = [];
    }
    applyFilter();
  });

  $(designerSelector).change(function () {
    if (this.checked) {
      // Uncheck all other checkboxes
      $(designerSelector).not(this).prop("checked", false);
      syncUncheckedStates(designerSelector, this);
      //$(this).parents(".dropdown").toggle();

      showOverlay();

      const filterVal = [$(this).val()];

      selectedFilters["designer"] = filterVal;
    } else {
      selectedFilters["designer"] = [];
    }
    syncCheckboxState(this);
    applyFilter();
  });

  $(lengthSelector).change(function () {
    if (this.checked) {
      // Uncheck all other checkboxes
      $(lengthSelector).not(this).prop("checked", false);
      syncUncheckedStates(lengthSelector, this);
      //$(this).parents(".dropdown").toggle();

      showOverlay();

      const filterVal = [$(this).val()];

      selectedFilters["length"] = filterVal;
    } else {
      selectedFilters["length"] = [];
    }
    syncCheckboxState(this);
    applyFilter();
  });

  $(stoneSizeSelector).change(function () {
    if (this.checked) {
      // Uncheck all other checkboxes
      $(stoneSizeSelector).not(this).prop("checked", false);
      syncUncheckedStates(stoneSizeSelector, this);
      //$(this).parents(".dropdown").toggle();

      showOverlay();

      const filterVal = [$(this).val()];

      selectedFilters["stoneSize"] = filterVal;
    } else {
      selectedFilters["stoneSize"] = [];
    }
    syncCheckboxState(this);
    applyFilter();
  });

  $(stoneShapeSelector).change(function () {
    syncCheckboxState(this);
    if (this.checked) {
      // Uncheck all other checkboxes

      showOverlay();
    }
    const filterVal = $(this).val();

    if (this.checked) {
      selectedFilters["stoneShape"].push(filterVal);
    } else {
      selectedFilters["stoneShape"] = selectedFilters["stoneShape"].filter((stone) => stone !== filterVal);
    }
    applyFilter();
  });

  $(diamondColorSelector).change(function () {
    syncCheckboxState(this);
    if (this.checked) {
      // Uncheck all other checkboxes
      showOverlay();
    }
    const filterVal = diamondColorFitlers[$(this).val()];

    if (this.checked) {
      selectedFilters["diamondColor"] = [...selectedFilters["diamondColor"], ...filterVal];
    } else {
      selectedFilters["diamondColor"] = selectedFilters["diamondColor"].filter((stone) => !filterVal.includes(stone));
    }
    applyFilter();
  });

  $(diamondClaritySelector).change(function () {
    syncCheckboxState(this);
    if (this.checked) {
      // Uncheck all other checkboxes
      showOverlay();
    }
    const filterVal = diamondClarityFilters[$(this).val()];

    if (this.checked) {
      selectedFilters["diamondClarity"] = [...selectedFilters["diamondClarity"], ...filterVal];
    } else {
      selectedFilters["diamondClarity"] = selectedFilters["diamondClarity"].filter((stone) => !filterVal.includes(stone));
    }
    applyFilter();
  });

  $(certificateLabSelector).change(function () {
    if (this.checked) {
      // Uncheck all other checkboxes
      $(certificateLabSelector).not(this).prop("checked", false);
      syncUncheckedStates(certificateLabSelector, this);
      showOverlay();
    }
    syncCheckboxState(this);
    const filterVal = [$(this).val()];

    if (this.checked) {
      selectedFilters["certificate"] = filterVal;
    } else {
      selectedFilters["certificate"] = [];
    }
    applyFilter();
  });

  $(ringTypeSelector).change(function () {
    if (this.checked) {
      // Uncheck all other checkboxes
      $(ringTypeSelector).not(this).prop("checked", false);
      syncUncheckedStates(ringTypeSelector, this);
      showOverlay();
    }
    syncCheckboxState(this);
    //$(this).parents(".dropdown").toggle();

    const filterVal = [$(this).val()];

    if (this.checked) {
      selectedFilters["ringType"] = filterVal;
      if (filterVal[0] === "Women Wedding" || filterVal[0] === "Men Wedding") {
        $(".filter-price-gender").show();
        $(".filter-price-engagement").hide();
      } else {
        $(".filter-price-gender").hide();
        $(".filter-price-engagement").show();
      }
    } else {
      selectedFilters["ringType"] = [];
      $(".filter-price-engagement").show();
    }
    applyFilter();
  });

  // Gender filter (for watches)
  $(document).on('change', genderSelector, function () {
    if (this.checked) {
      // Uncheck all other checkboxes
      $(genderSelector).not(this).prop("checked", false);
      syncUncheckedStates(genderSelector, this);
      showOverlay();
    }
    syncCheckboxState(this);
    //$(this).parents(".dropdown").toggle();

    const filterVal = [$(this).val()];

    if (this.checked) {
      selectedFilters["gender"] = filterVal;
    } else {
      selectedFilters["gender"] = [];
    }
    applyFilter();
  });

  $(productTypeSelector).change(function () {
    if (this.checked) {
      // Uncheck all other checkboxes
      $(productTypeSelector).not(this).prop("checked", false);
      syncUncheckedStates(productTypeSelector, this);
      showOverlay();
    }
    syncCheckboxState(this);
    //$(this).parents(".dropdown").toggle();

    const filterVal = [$(this).val()];

    if (this.checked) {
      selectedFilters["productType"] = filterVal;
    } else {
      selectedFilters["productType"] = [];
    }
    applyFilter();
  });

  $(movementSelector).change(function () {
    if (this.checked) {
      // Uncheck all other checkboxes
      $(movementSelector).not(this).prop("checked", false);
      syncUncheckedStates(movementSelector, this);
      showOverlay();
    }
    syncCheckboxState(this);
    //$(this).parents(".dropdown").toggle();

    const filterVal = [$(this).val()];

    if (this.checked) {
      selectedFilters["movement"] = filterVal;
    } else {
      selectedFilters["movement"] = [];
    }
    applyFilter();
  });

  $(caseSizeSelector).change(function () {
    if (this.checked) {
      // Uncheck all other checkboxes
      $(caseSizeSelector).not(this).prop("checked", false);
      syncUncheckedStates(caseSizeSelector, this);
      showOverlay();
    }
    syncCheckboxState(this);
    //$(this).parents(".dropdown").toggle();

    const filterVal = [$(this).val()];

    if (this.checked) {
      selectedFilters["caseSize"] = filterVal;
    } else {
      selectedFilters["caseSize"] = [];
    }
    applyFilter();
  });

  // Condition filter (for watches)
  $(document).on('change', conditionSelector, function () {
    syncCheckboxState(this);
    showOverlay();

    const filterVal = $(this).val();

    if (this.checked) {
      selectedFilters["condition"].push(filterVal);
    } else {
      selectedFilters["condition"] = selectedFilters["condition"].filter((condition) => condition !== filterVal);
    }
    applyFilter();
  });

  // Handle submenu visibility for earring type filter
  $(document).on("change", ".fiter-earring-type .has-submenu", function () {
    syncCheckboxState(this);
    const $submenu = $(this).closest("label").next(".sub-menu");

    // Hide all other submenus first
    $(".fiter-earring-type .sub-menu").not($submenu).hide();

    if (this.checked) {
      $submenu.show();
    } else {
      $submenu.hide();
      // Clear any selected options in the submenu
      $submenu.find('input[type="checkbox"]').prop("checked", false);

      // Clear the corresponding filter arrays
      if ($(this).val() === "Hanging & Hoop") {
        selectedFilters["hangingType"] = [];
      } else if ($(this).val() === "Diamond Studs") {
        selectedFilters["studSize"] = [];
      } else {
        selectedFilters["stones"] = [];
      }
    }
  });

  // When selecting a different parent option, uncheck others
  $(document).on("change", ".fiter-earring-type .parent-option > label > input", function () {
    syncCheckboxState(this);
    if (this.checked) {
      // Uncheck all other parent options
      $(".fiter-earring-type .parent-option > label > input").not(this).prop("checked", false);
      syncUncheckedStates(".fiter-earring-type .parent-option > label > input", this);

      // Clear all filters except the current one
      if (!$(this).hasClass("has-submenu")) {
        selectedFilters["hangingType"] = [];
        selectedFilters["studSize"] = [];
        selectedFilters["stones"] = [];
        $(".fiter-earring-type .sub-menu").hide();
      }
    }
  });

  $(earringTypeSelector).change(function () {
    if (this.checked) {
      // Uncheck all other checkboxes
      $(hangingTypeSelector).prop("checked", false);
      $(studSizeSelector).prop("checked", false);
      $(earringColoredGemstoneSelector).prop("checked", false);

      $(earringTypeSelector).not(this).prop("checked", false);
      syncUncheckedStates(earringTypeSelector, this);
      showOverlay();
    }
    syncCheckboxState(this);
    //$(this).parents(".dropdown").toggle();

    const filterVal = [$(this).val()];

    if (this.checked) {
      selectedFilters["hangingType"] = [];
      selectedFilters["studSize"] = [];
      selectedFilters["stones"] = [];
      selectedFilters["earringType"] = filterVal;
    } else {
      selectedFilters["earringType"] = [];
    }
    applyFilter();
  });

  $(hangingTypeSelector).change(function () {
    if (this.checked) {
      // Uncheck all other checkboxes
      $(hangingTypeSelector).not(this).prop("checked", false);
      syncUncheckedStates(hangingTypeSelector, this);
      showOverlay();
    }
    syncCheckboxState(this);
    //$(this).parents(".dropdown").toggle();

    const filterVal = [$(this).val()];

    if (this.checked) {
      selectedFilters["hangingType"] = filterVal;
    } else {
      selectedFilters["hangingType"] = [];
    }
    applyFilter();
  });

  $(studSizeSelector).change(function () {
    if (this.checked) {
      // Uncheck all other checkboxes
      $(studSizeSelector).not(this).prop("checked", false);
      syncUncheckedStates(studSizeSelector, this);
      showOverlay();
    }
    syncCheckboxState(this);
    //$(this).parents(".dropdown").toggle();

    const filterVal = [$(this).val()];

    if (this.checked) {
      selectedFilters["studSize"] = filterVal;
    } else {
      selectedFilters["studSize"] = [];
    }
    applyFilter();
  });

  // Define applyFilter globally so it can be called from external scripts
  // Track pending filter operation to avoid duplicates
  let filterTimeout = null;
  
  window.applyFilter = () => {
    
    // Reset to page 1 when filters change
    currentPage = 1;
    
    // Update URL to remove page parameter
    const url = new URL(window.location);
    url.searchParams.delete('page');
    history.replaceState({ page: 1 }, '', url);
    
    // Save filter state to sessionStorage (for back button persistence)
    sessionStorage.setItem('filter-collection-handle', handle);
    sessionStorage.setItem('filter-state', JSON.stringify(selectedFilters));
    
    // Update filter active indicators
    updateFilterIndicators();
    
    // Update mobile filter badge count
    updateMobileFilterBadge();
    
    // Debounce: cancel any pending filter operation
    if (filterTimeout) {
      clearTimeout(filterTimeout);
    }
    
    // Show overlay and fade out products
    showOverlay();
    
    // Wait for fade-out to complete before updating content
    waitForFadeOut(() => {
      // If products already loaded, filter immediately
      if (all_products.length > 0) {
        performFiltering();
        return;
      }
      
      // Otherwise wait for products with a timeout
      const maxWait = 10000; // 10 seconds max wait
      const startTime = Date.now();
      
      const checkProducts = () => {
        if (all_products.length > 0) {
          performFiltering();
        } else if (Date.now() - startTime < maxWait) {
          filterTimeout = setTimeout(checkProducts, 100);
        } else {
          console.error('Timeout waiting for products');
          hideOverlay();
        }
      };
      
      filterTimeout = setTimeout(checkProducts, 100);
    });
  };
  
  // Separate function for the actual filtering logic
  function performFiltering(onCompleteCallback) {
    const filterStartTime = performance.now();
    
    // Reset debug flags for emerald logging
    window._emeraldPathLogged = false;
    
    
    // Reset debug counter for All Others
    window._allOthersDebugCount = 0;
    
    // Check if no filters are applied
    if (
          selectedFilters.material.length === 0 &&
          selectedFilters.stones.length === 0 &&
          selectedFilters.price.length === 0 &&
          selectedFilters.designer.length === 0 &&
          selectedFilters.length.length === 0 &&
          selectedFilters.stoneShape.length === 0 &&
          selectedFilters.stoneSize.length === 0 &&
          selectedFilters.diamondColor.length === 0 &&
          selectedFilters.diamondClarity.length === 0 &&
          selectedFilters.certificate.length === 0 &&
          selectedFilters.ringType.length === 0 &&
          selectedFilters.material_band.length === 0 &&
          selectedFilters.stonesDesigner.length === 0 &&
          selectedFilters.gender.length === 0 &&
          selectedFilters.watchMaterial.length === 0 &&
          selectedFilters.materialType.length === 0 &&
          selectedFilters.movement.length === 0 &&
          selectedFilters.caseSize.length === 0 &&
          selectedFilters.productType.length === 0 &&
          selectedFilters.condition.length === 0 &&
          selectedFilters.earringType.length === 0 &&
          selectedFilters.hangingType.length === 0 &&
          selectedFilters.studSize.length === 0
        ) {
          filter_products = all_products;
        } else {
          filter_products = all_products.filter((p) => {
            if (!p.metafields) return false;

            let materialMatches = true;
            let materialBandMatches = true;
            let stonesMatch = true;
            let priceMatches = true;
            let designerMatches = true;
            let lengthMatches = true;
            let shapeMatches = true;
            let sizeMatches = true;
            let diamondColorMatches = true;
            let diamondClarityMatches = true;
            let certificateMatches = true;
            let ringTypeMatches = true;
            let stonesDesignerMatches = true;
            let genderMatches = true;
            let watchMaterialMatches = true;
            let materialTypeMatches = true;
            let movementMatches = true;
            let caseSizeMatches = true;
            let productTypeMatches = true;
            let conditionMatches = true;
            let earringTypeMatches = true;
            let hangingTypeMatches = true;
            let studSizeMatches = true;

            // Extract the necessary metafield values
            const material = p.metafields.find((m) => m?.key === "material")?.value;
            const totalSideStones = p.metafields.find((m) => m?.key === "total_side_stones")?.value;
            const sideStoneRaw = p.metafields.find((m) => m?.key === "side_gemstones")?.value;
            const centerStoneRaw = p.metafields.find((m) => m?.key === "center_stone")?.value;
            
            // Parse stone values - they may be JSON arrays
            let sideStone = sideStoneRaw;
            let centerStone = centerStoneRaw;
            try {
              if (sideStoneRaw) {
                const parsed = JSON.parse(sideStoneRaw);
                sideStone = Array.isArray(parsed) ? parsed[0] : parsed;
              }
            } catch (e) { /* keep original value */ }
            try {
              if (centerStoneRaw) {
                const parsed = JSON.parse(centerStoneRaw);
                centerStone = Array.isArray(parsed) ? parsed[0] : parsed;
              }
            } catch (e) { /* keep original value */ }
            const length = p.metafields.find((m) => m?.key === "length_in")?.value;
            const priceMin = parseFloat(p.priceRange?.minVariantPrice?.amount);
            const center_stone_shape = p.metafields.find((m) => m?.key === "center_stone_shape")?.value;
            const side_stones_shape = p.metafields.find((m) => m?.key === "side_stones_shape")?.value;
            const center_stones_size = p.metafields.find((m) => m?.key === "center_stone_weight_ct")?.value;
            const center_stone_color = p.metafields.find((m) => m?.key === "center_stone_color")?.value;
            const center_stone_clarity = p.metafields.find((m) => m?.key === "center_stone_clarity")?.value;
            const certificate = p.metafields.find((m) => m?.key === "certificate")?.value;
            const gender = p.metafields.find((m) => m?.key === "gender")?.value;
            const movement = p.metafields.find((m) => m?.key === "movement")?.value;
            const caseSize = p.metafields.find((m) => m?.key === "case_size_mm")?.value;
            const stud1TypeRaw = p.metafields.find((m) => m?.key === "earring_1_gemstone_1_type")?.value;
            const stud2TypeRaw = p.metafields.find((m) => m?.key === "earring_2_gemstone_2_type_")?.value;
            
            // Parse stud type values - they may be JSON arrays
            let stud1Type = stud1TypeRaw;
            let stud2Type = stud2TypeRaw;
            try {
              if (stud1TypeRaw) {
                const parsed = JSON.parse(stud1TypeRaw);
                stud1Type = Array.isArray(parsed) ? parsed[0] : parsed;
              }
            } catch (e) { /* keep original value */ }
            try {
              if (stud2TypeRaw) {
                const parsed = JSON.parse(stud2TypeRaw);
                stud2Type = Array.isArray(parsed) ? parsed[0] : parsed;
              }
            } catch (e) { /* keep original value */ }
            const stud1Size = p.metafields.find((m) => m?.key === "stud_1_size_ct")?.value;
            const stud2Size = p.metafields.find((m) => m?.key === "stud_2_size_ct")?.value;
            const studCombinedSize = p.metafields.find((m) => m?.key === "earring_1_gemstone_1_total_weight_cttw_")?.value;

            // Check Material filter - use fuzzy matching for flexibility
            if (selectedFilters["material"].length > 0) {
              if (!material) {
                materialMatches = false;
              } else {
                let parsedMaterial;
                try {
                  parsedMaterial = JSON.parse(material)[0].toLowerCase();
                } catch (e) {
                  parsedMaterial = material.toLowerCase();
                }
                
                const filterKey = selectedFilters["material"][0];
                
                if (filterKey === "All Others" || filterKey === "Others") {
                  // "All Others" = not gold AND not platinum (check both metafield and title)
                  const isGold = parsedMaterial.includes("gold");
                  const isPlatinum = parsedMaterial.includes("platinum") || (p.title && p.title.toLowerCase().includes("platinum"));
                  materialMatches = !isGold && !isPlatinum;
                } else if (filterKey === "Platinum" || selectedFilters["material"].includes("Platinum")) {
                  // Platinum filter - fuzzy match any material containing "platinum"
                  materialMatches = parsedMaterial.includes("platinum");
                } else if (filterKey === "White Gold" || filterKey === "Yellow Gold" || filterKey === "All Gold Types" || filterKey === "Gold") {
                  // Gold filters - fuzzy match any material containing "gold"
                  materialMatches = parsedMaterial.includes("gold");
                  // For specific gold types, also check for the specific type
                  if (filterKey === "White Gold") {
                    materialMatches = parsedMaterial.includes("white gold");
                  } else if (filterKey === "Yellow Gold") {
                    materialMatches = parsedMaterial.includes("yellow gold");
                  }
                } else {
                  // Default: try exact match first, then fuzzy match
                  try {
                    const exactMaterial = JSON.parse(material)[0];
                    materialMatches = selectedFilters["material"].includes(exactMaterial);
                  } catch (e) {
                    materialMatches = selectedFilters["material"].includes(material);
                  }
                  // If no exact match, try fuzzy match with filter key
                  if (!materialMatches) {
                    materialMatches = parsedMaterial.includes(filterKey.toLowerCase());
                  }
                }
              }
            }

            // Check Stones filter
            if (selectedFilters["stones"].length > 0) {
              if (selectedFilters["stones"].includes("Multi-Type")) {
                // Multi-Type: Product has multiple DIFFERENT stone types anywhere
                // Collect all stone types from metafields, title, and description
                const stoneTypes = new Set();
                
                // Add metafield stone values (normalized to lowercase)
                if (centerStone) stoneTypes.add(centerStone.toLowerCase().trim());
                if (sideStone) stoneTypes.add(sideStone.toLowerCase().trim());
                if (stud1Type) stoneTypes.add(stud1Type.toLowerCase().trim());
                if (stud2Type) stoneTypes.add(stud2Type.toLowerCase().trim());
                
                // Check title for common stone types
                const titleLower = p.title?.toLowerCase() || '';
                const commonStones = ['diamond', 'ruby', 'sapphire', 'emerald', 'amethyst', 'topaz', 'opal', 'pearl', 'aquamarine', 'garnet', 'peridot', 'citrine', 'tanzanite', 'turquoise', 'onyx', 'morganite'];
                commonStones.forEach(stone => {
                  if (titleLower.includes(stone)) {
                    // Skip "emerald" if it's "emerald cut"
                    if (stone === 'emerald' && /emerald\s*(cut|center|shape|diamond|-cut)/i.test(titleLower)) {
                      return;
                    }
                    stoneTypes.add(stone);
                  }
                });
                
                // Product matches if it has 2 or more different stone types
                stonesMatch = stoneTypes.size >= 2;
              } else if (selectedFilters["stones"].includes("None")) {
                // Check that product has no stones in metafields AND no stone names in title/description
                const hasNoStoneMetafields = !sideStone && !centerStone && !totalSideStones;
                const titleHasNoStones = containsNoStones(p.title) && !stoneMatches(p.title, "Diamond");
                const descHasNoStones = !p.description || (containsNoStones(p.description) && !stoneMatches(p.description, "Diamond"));
                
                stonesMatch = hasNoStoneMetafields && titleHasNoStones && descHasNoStones;
                
              } else if (selectedFilters["stones"].includes("Colored Gemstone")) {
                // Check if specific gemstones are selected in the submenu (e.g., "Emerald" under "Colored Gemstone")
                const specificGemsSelected = selectedFilters["stones"].filter(s => 
                  s !== "Colored Gemstone" && coloredGemstones.includes(s)
                );
                
                // Cut-style gemstones need special handling to avoid matching "Emerald Cut", etc.
                const cutStyleGems = ['emerald', 'marquise', 'pear', 'oval', 'cushion', 'radiant', 'princess', 'heart', 'asscher'];
                const titleLower = p.title?.toLowerCase() || '';
                
                if (specificGemsSelected.length > 0) {
                  // SPECIFIC GEMS SELECTED - use strict matching for those specific gems only
                  // Check metafields BUT verify against title for cut-style gems
                  const hasSpecificGemInMetafields = specificGemsSelected.some(gem => {
                    const gemLower = gem.toLowerCase();
                    const matchesMetafield = 
                      centerStone?.toLowerCase() === gemLower ||
                      sideStone?.toLowerCase() === gemLower ||
                      stud1Type?.toLowerCase() === gemLower ||
                      stud2Type?.toLowerCase() === gemLower;
                    
                    if (!matchesMetafield) return false;
                    
                    // For cut-style gemstones, verify the title doesn't indicate it's a cut style
                    if (cutStyleGems.includes(gemLower)) {
                      const cutStylePattern = new RegExp(`${gemLower}\\s*(cut|center|shape|diamond|-cut)`, 'i');
                      if (cutStylePattern.test(titleLower)) {
                        // Title says it's a cut style, don't trust the metafield
                        return false;
                      }
                    }
                    return true;
                  });
                  
                  // Check title using stoneMatches (which has built-in cut-style exclusion)
                  const hasSpecificGemInTitle = specificGemsSelected.some(gem => 
                    stoneMatches(p.title, gem)
                  );
                  
                  // Debug for emerald
                  if (specificGemsSelected.includes('Emerald') && titleLower.includes('emerald')) {
                    console.log('%c[EMERALD - SPECIFIC GEM PATH]', 'background: #080; color: #fff;', {
                      title: p.title?.substring(0, 60),
                      hasSpecificGemInMetafields,
                      hasSpecificGemInTitle,
                      centerStone,
                      sideStone,
                      willMatch: hasSpecificGemInMetafields || hasSpecificGemInTitle
                    });
                  }
                  
                  stonesMatch = hasSpecificGemInMetafields || hasSpecificGemInTitle;
                } else {
                  // NO SPECIFIC GEMS - match any colored gemstone (broad filter)
                  // Helper to check if metafield value is a real gem (not a cut-style reference in title)
                  const isRealGemInMetafield = (metafieldValue) => {
                    if (!stoneIsColoredGemstone(metafieldValue)) return false;
                    const gemLower = metafieldValue.toLowerCase();
                    // For cut-style gems, verify title doesn't indicate it's a cut style
                    // "Emerald Cut", "Emerald Diamond", "Emerald Shape", etc.
                    if (cutStyleGems.includes(gemLower)) {
                      const cutStylePattern = new RegExp(`${gemLower}\\s*(cut|center|shape|diamond|-cut)`, 'i');
                      if (cutStylePattern.test(titleLower)) {
                        return false; // Title says it's a cut style, not actual gem
                      }
                    }
                    return true;
                  };
                  
                  const hasColoredCenter = isRealGemInMetafield(centerStone);
                  const hasColoredSide = isRealGemInMetafield(sideStone);
                  const hasColoredStud1 = isRealGemInMetafield(stud1Type);
                  const hasColoredStud2 = isRealGemInMetafield(stud2Type);
                  const hasColoredInTitle = containsColoredGemstones(p.title);
                  
                  // Do not match against description - only metafields and title
                  stonesMatch = hasColoredCenter || hasColoredSide || hasColoredStud1 || hasColoredStud2 || hasColoredInTitle;
                }
              } else {
                // For cut-style gemstones (like Emerald), stoneMatches now handles exclusion properly
                const cutStyleGemstones = ['emerald', 'marquise', 'pear', 'oval', 'cushion', 'radiant', 'princess', 'heart', 'asscher'];
                
                // Check if any selected filter is a cut-style gemstone
                const selectedCutStyleGems = selectedFilters["stones"].filter(f => cutStyleGemstones.includes(f.toLowerCase()));
                const selectedRegularGems = selectedFilters["stones"].filter(f => !cutStyleGemstones.includes(f.toLowerCase()));
                
                // Debug: Check if emerald filter is active
                const isEmeraldFilter = selectedCutStyleGems.some(g => g.toLowerCase() === 'emerald');
                const titleHasEmerald = p.title?.toLowerCase().includes('emerald');
                
                // Check metafields for regular gems (do not match against description)
                let regularGemMatch = false;
                if (selectedRegularGems.length > 0) {
                  regularGemMatch = 
                    selectedRegularGems.includes(stud1Type) ||
                    selectedRegularGems.includes(stud2Type) ||
                    selectedRegularGems.includes(sideStone) ||
                    selectedRegularGems.includes(centerStone) ||
                    stoneMatchesAny(p.title, selectedRegularGems);
                }
                
                // Check for cut-style gemstones - need extra verification to avoid "Emerald Cut" matching "Emerald"
                let cutStyleGemMatch = false;
                for (const gem of selectedCutStyleGems) {
                  const gemLower = gem.toLowerCase();
                  const titleLower = p.title.toLowerCase();
                  
                  // For cut-style gems, check if title indicates it's a cut style
                  // "Emerald Cut", "Emerald Diamond", "Emerald Shape", "Emerald Center", etc.
                  const cutStylePattern = new RegExp(`${gemLower}\\s*(cut|center|shape|diamond|-cut)`, 'i');
                  const titleIndicatesCutStyle = cutStylePattern.test(titleLower);
                  
                  // Debug logging for emerald filter
                  if (gemLower === 'emerald' && titleHasEmerald) {
                    console.log('%c[EMERALD FILTER DEBUG]', 'background: #800; color: #fff;', {
                      title: p.title?.substring(0, 60),
                      titleIndicatesCutStyle,
                      centerStone,
                      sideStone,
                      stud1Type,
                      stud2Type
                    });
                  }
                  
                  // If title indicates a cut style, SKIP this product entirely for this gem
                  // (unless there's evidence of an ACTUAL gem elsewhere - handled by stoneMatches)
                  if (titleIndicatesCutStyle) {
                    // Only allow if stoneMatches finds definitive evidence of actual stone
                    // stoneMatches has built-in logic to require definitive patterns when cut-style is detected
                    const stoneMatchResult = stoneMatches(p.title, gem);
                    
                    // Debug: Log stoneMatches result
                    if (gemLower === 'emerald' && titleHasEmerald) {
                      console.log('%c[EMERALD - CUT STYLE PATH]', 'background: #f80; color: #000;', {
                        title: p.title?.substring(0, 60),
                        stoneMatchResult,
                        willMatch: stoneMatchResult
                      });
                    }
                    
                    if (stoneMatchResult) {
                      cutStyleGemMatch = true;
                      break;
                    }
                    // Don't check metafields if title says it's a cut style
                    continue;
                  }
                  
                  // Title does NOT indicate a cut style - check metafields
                  const metafieldMatch = gemLower === (stud1Type || '').toLowerCase() || 
                      gemLower === (stud2Type || '').toLowerCase() || 
                      gemLower === (sideStone || '').toLowerCase() || 
                      gemLower === (centerStone || '').toLowerCase();
                  
                  if (metafieldMatch) {
                    if (gemLower === 'emerald' && titleHasEmerald) {
                      console.log('%c[EMERALD - METAFIELD MATCH]', 'background: #0a0; color: #fff;', {
                        title: p.title?.substring(0, 60),
                        matchedValue: gemLower === centerStone?.toLowerCase() ? 'centerStone' : 
                                      gemLower === sideStone?.toLowerCase() ? 'sideStone' :
                                      gemLower === stud1Type?.toLowerCase() ? 'stud1Type' : 'stud2Type'
                      });
                    }
                    cutStyleGemMatch = true;
                    break;
                  }
                  
                  // Also check title for non-cut-style references
                  const titleMatch = stoneMatches(p.title, gem);
                  if (titleMatch) {
                    if (gemLower === 'emerald' && titleHasEmerald) {
                      console.log('%c[EMERALD - TITLE MATCH (no cut style)]', 'background: #00a; color: #fff;', {
                        title: p.title?.substring(0, 60)
                      });
                    }
                    cutStyleGemMatch = true;
                    break;
                  }
                }
                
                stonesMatch = regularGemMatch || cutStyleGemMatch;
              }
            }

            if (selectedFilters["stonesDesigner"].length > 0) {
              if (selectedFilters["stonesDesigner"].includes("None")) {
                stonesDesignerMatches = !sideStone && !centerStone && !totalSideStones && containsNoStones(p.title) && containsNoStones(p.description);
              } else if (selectedFilters["stonesDesigner"].includes("Colored Gemstone")) {
                // Cut-style gemstones need special handling to avoid matching "Emerald Cut", etc.
                const cutStyleGemsDesigner = ['emerald', 'marquise', 'pear', 'oval', 'cushion', 'radiant', 'princess', 'heart', 'asscher'];
                const titleLowerDesigner = p.title?.toLowerCase() || '';
                
                // Helper to check if metafield value is a real gem (not a cut-style reference in title)
                const isRealGemInMetafieldDesigner = (metafieldValue) => {
                  if (!stoneIsColoredGemstone(metafieldValue)) return false;
                  const gemLower = metafieldValue.toLowerCase();
                  // For cut-style gems, verify title doesn't indicate it's a cut style
                  // "Emerald Cut", "Emerald Diamond", "Emerald Shape", etc.
                  if (cutStyleGemsDesigner.includes(gemLower)) {
                    const cutStylePattern = new RegExp(`${gemLower}\\s*(cut|center|shape|diamond|-cut)`, 'i');
                    if (cutStylePattern.test(titleLowerDesigner)) {
                      return false; // Title says it's a cut style, not actual gem
                    }
                  }
                  return true;
                };
                
                // Do not match against description - only metafields and title
                stonesDesignerMatches =
                  isRealGemInMetafieldDesigner(sideStone) ||
                  isRealGemInMetafieldDesigner(centerStone) ||
                  isRealGemInMetafieldDesigner(stud1Type) ||
                  isRealGemInMetafieldDesigner(stud2Type) ||
                  containsColoredGemstones(p.title);
              } else {
                // Do not match against description - only metafields and title
                stonesDesignerMatches =
                  selectedFilters["stonesDesigner"].includes(sideStone) ||
                  selectedFilters["stonesDesigner"].includes(centerStone) ||
                  stoneMatchesAny(p.title, selectedFilters["stonesDesigner"]);
              }
            }

            // Check Price filter
            if (selectedFilters["price"].length > 0) {
              const priceMinFilter = selectedFilters["price"][0];
              const priceMaxFilter = selectedFilters["price"][1];
              priceMatches = priceMin >= priceMinFilter && priceMin <= priceMaxFilter;
            }

            if (selectedFilters["designer"].length > 0) {
              if (selectedFilters["designer"][0] === "no") {
                // "No" = NOT a designer brand = is Estate Watch vendor
                designerMatches = isEstateWatchVendor(p.vendor);
              }
              if (selectedFilters["designer"][0] === "yes") {
                // "Yes" = IS a designer brand = is NOT Estate Watch vendor
                designerMatches = !isEstateWatchVendor(p.vendor);
              }
            }

            if (selectedFilters["length"].length > 0) {
              // Products without a length set should be excluded
              if (!length) {
                lengthMatches = false;
              } else if (selectedFilters["length"][0].includes("-")) {
                const base = selectedFilters["length"][0].replace("-", "");
                lengthMatches = parseFloat(length) < parseFloat(base);
              } else if (selectedFilters["length"][0].includes("+")) {
                const base = selectedFilters["length"][0].replace("+", "");
                lengthMatches = parseFloat(length) >= parseFloat(base);
              }
            }

            if (selectedFilters["stoneShape"].length > 0) {
              // Main shapes that have dedicated filter options (case-insensitive comparison)
              const mainShapes = [
                "round",
                "princess",
                "emerald",
                "oval",
                "pear",
                "radiant",
                "cushion",
                "marquise",
                "trilliant",
                "heart",
              ];
              
              // Normalize shape values for comparison
              const centerShapeLower = center_stone_shape ? center_stone_shape.toLowerCase().trim() : null;
              const sideShapeLower = side_stones_shape ? side_stones_shape.toLowerCase().trim() : null;
              
              // Check if shape is a main shape (check if it STARTS WITH any main shape name)
              const isMainShape = (shapeLower) => {
                if (!shapeLower) return false;
                return mainShapes.some(main => shapeLower === main || shapeLower.startsWith(main + " "));
              };
              
              if (selectedFilters["stoneShape"].includes("Others")) {
                // Get any specific shapes selected (not "Others")
                const specificShapes = selectedFilters["stoneShape"].filter(s => s !== "Others");
                
                // "All Others" filter logic:
                // - Only consider the CENTER stone shape (side stones don't determine category)
                // - Show products where center stone is NOT one of the main 10 shapes
                // - Products with no center shape are excluded
                const centerIsOther = centerShapeLower && !isMainShape(centerShapeLower);
                
                if (specificShapes.length > 0) {
                  // If other specific shapes are also selected, match those OR match "other" center shapes
                  const matchesSpecific = specificShapes.some(s => 
                    s.toLowerCase() === centerShapeLower || 
                    (centerShapeLower && centerShapeLower.startsWith(s.toLowerCase()))
                  );
                  shapeMatches = matchesSpecific || centerIsOther;
                } else {
                  // Only "Others" is selected - show only items where CENTER shape is not a main shape
                  shapeMatches = centerIsOther;
                }
              } else {
                // Standard shape matching - check exact match or starts with
                const matchesShape = (filterShape, productShape) => {
                  if (!productShape) return false;
                  const filterLower = filterShape.toLowerCase();
                  return productShape === filterLower || productShape.startsWith(filterLower + " ");
                };
                
                shapeMatches = selectedFilters["stoneShape"].some(s => matchesShape(s, centerShapeLower)) || 
                               selectedFilters["stoneShape"].some(s => matchesShape(s, sideShapeLower));
              }
            }

            // Stone Size filter - matches against center_stone_weight_ct metafield
            if (selectedFilters["stoneSize"].length > 0) {
              const sizeRange = selectedFilters["stoneSize"][0];
              // Parse range format "min~max" (e.g., "1.0~1.99")
              const [minSize, maxSize] = sizeRange.split("~").map(parseFloat);
              
              // Parse the stone weight from metafield - handle JSON array format
              let stoneWeight = null;
              if (center_stones_size) {
                try {
                  // May be stored as JSON array like ["1.5"]
                  const parsed = JSON.parse(center_stones_size);
                  stoneWeight = parseFloat(Array.isArray(parsed) ? parsed[0] : parsed);
                } catch (e) {
                  // Plain number string
                  stoneWeight = parseFloat(center_stones_size);
                }
              }
              
              // Check if stone weight falls within the selected range
              if (stoneWeight !== null && !isNaN(stoneWeight)) {
                sizeMatches = stoneWeight >= minSize && stoneWeight <= maxSize;
              } else {
                // No stone size data - doesn't match
                sizeMatches = false;
              }
            }

            if (selectedFilters["diamondColor"].length > 0) {
              const filter = selectedFilters["diamondColor"];

              diamondColorMatches = filter.includes(center_stone_color);
            }

            if (selectedFilters["diamondClarity"].length > 0) {
              const filter = selectedFilters["diamondClarity"];

              diamondClarityMatches = filter.includes(center_stone_clarity);
            }

            if (selectedFilters["certificate"].length > 0) {
              const filter = selectedFilters["certificate"];
              
              // Parse certificate value safely (metafield is a List type)
              let certValue = null;
              if (certificate) {
                try {
                  const parsed = JSON.parse(certificate);
                  certValue = Array.isArray(parsed) ? parsed[0] : parsed;
                } catch (e) {
                  certValue = certificate; // Use raw value if not JSON
                }
              }
              
              // Values that count as "uncertified" (not a formal lab certification)
              const uncertifiedValues = ["None", "Jeweler-Graded"];

              if (filter[0] === "GIA") {
                certificateMatches = certValue === "GIA";
              }

              if (filter[0] === "Other") {
                // Other Lab = has a certificate that is NOT GIA and NOT uncertified
                certificateMatches = !!certValue && certValue !== "GIA" && !uncertifiedValues.includes(certValue);
              }

              if (filter[0] === "Uncertified") {
                // Uncertified = no certificate metafield OR value is None/Jeweler-Graded
                certificateMatches = !certValue || uncertifiedValues.includes(certValue);
              }
            }

            if (selectedFilters["ringType"].length > 0) {
              const filter = selectedFilters["ringType"];
              const titleLower = (p.title || '').toLowerCase();
              
              // Check if this is an engagement ring (by productType OR title containing "engagement")
              const isEngagementRing = p.productType === "Engagement Ring" || 
                titleLower.includes("engagement ring") ||
                titleLower.includes("engagement diamond") ||
                (titleLower.includes("solitaire") && titleLower.includes("ring") && !titleLower.includes("band"));

              // Check if this is a wedding band
              const isWeddingBand = titleLower.includes("wedding band") || 
                titleLower.includes("wedding ring") ||
                (titleLower.includes("band") && !titleLower.includes("engagement"));

              if (filter[0] === "Engagement Rings") {
                ringTypeMatches = isEngagementRing;
              }

              if (filter[0] === "Women Wedding") {
                // Must be Women's wedding band AND must NOT be an engagement ring
                const isWomens = !!gender && JSON.parse(gender)[0] === "Women's";
                // Match if: has Women's gender, OR has wedding band in title - but NEVER if it's an engagement ring
                ringTypeMatches = !isEngagementRing && (isWomens || isWeddingBand);
              }

              if (filter[0] === "Men Wedding") {
                // Must be Men's wedding band AND must NOT be an engagement ring
                const isMens = !!gender && JSON.parse(gender)[0] === "Men's";
                ringTypeMatches = !isEngagementRing && (isMens || isWeddingBand);
              }
            }

            if (selectedFilters["material_band"].length > 0) {
              const filter = selectedFilters["material_band"];
              if (filter[0] === "White Gold") {
                materialBandMatches = material && material.includes("White Gold");
              }

              if (filter[0] === "Yellow Gold") {
                materialBandMatches = material && material.includes("Yellow Gold");
              }

              if (filter[0] === "All Others") {
                materialBandMatches = material && !material.includes("Yellow Gold") && !material.includes("White Gold");
              }
            }

            if (selectedFilters["gender"].length > 0) {
              const filter = selectedFilters["gender"];
              if (gender) {
                try {
                  const parsedGender = JSON.parse(gender);
                  // Check if array includes the selected gender value
                  genderMatches = Array.isArray(parsedGender) 
                    ? parsedGender.includes(filter[0])
                    : parsedGender === filter[0];
                } catch (e) {
                  // Gender might be a plain string, not JSON
                  genderMatches = gender === filter[0];
                }
              } else {
                genderMatches = false;
              }
            }

            if (selectedFilters["watchMaterial"].length > 0) {
              const filter = selectedFilters["watchMaterial"];

              watchMaterialMatches = material && filter.includes(JSON.parse(material)[0]);
            }

            if (selectedFilters["materialType"].length > 0) {
              const filter = selectedFilters["materialType"];
              if (material) {
                try {
                  const parsedMaterial = JSON.parse(material);
                  materialTypeMatches = filter.includes(parsedMaterial[0]);
                } catch (e) {
                  // Material might be a plain string, not JSON
                  materialTypeMatches = filter.includes(material);
                }
              } else {
                materialTypeMatches = false;
              }
            }

            if (selectedFilters["movement"].length > 0) {
              const filter = selectedFilters["movement"];
              if (filter[0] === "Others") {
                const f = ["Eco Drive", "Solar", "Electrostatic"];
                movementMatches = movement && f.includes(movement);
              } else {
                movementMatches = movement && filter.includes(movement);
              }
            }

            if (selectedFilters["caseSize"].length > 0) {
              const filter = selectedFilters["caseSize"];
              const min = parseFloat(filter[0].split("~")[0]);
              const max = parseFloat(filter[0].split("~")[1]);
              caseSizeMatches = min < parseFloat(caseSize) && parseFloat(caseSize) < max;
            }

            if (selectedFilters["productType"].length > 0) {
              const filter = selectedFilters["productType"];
              if (filter[0] === "Others") {
                const f = ["Rings", "Necklaces", "Cufflinks", "Pocket Knives", "Pocket Knife"];
                productTypeMatches = !f.includes(p.productType);
              } else if (filter[0] === "Pocket Knives") {
                const f = ["Pocket Knives", "Pocket Knife"];
                productTypeMatches = f.includes(p.productType);
              } else {
                productTypeMatches = p.productType === filter[0];
              }
            }

            if (selectedFilters["condition"].length > 0 && selectedFilters["condition"].length !== 2) {
              const filter = selectedFilters["condition"][0];
              conditionMatches = p.tags && Array.isArray(p.tags) && p.tags.includes(filter);
            }

            if (selectedFilters["earringType"].length > 0) {
              const filter = selectedFilters["earringType"][0];
              
              // Cut-style gemstones need special handling to avoid matching "Emerald Cut", etc.
              const cutStyleGemstones = ['emerald', 'marquise', 'pear', 'oval', 'cushion', 'radiant', 'princess', 'heart', 'asscher'];
              const titleLower = p.title.toLowerCase();
              
              // Helper to check if metafield value is a real gem (not a cut-style reference in title)
              const isRealGemInMetafield = (metafieldValue) => {
                if (!stoneIsColoredGemstone(metafieldValue)) return false;
                const gemLower = metafieldValue.toLowerCase();
                // For cut-style gems, verify title doesn't indicate it's a cut style
                // "Emerald Cut", "Emerald Diamond", "Emerald Shape", etc.
                if (cutStyleGemstones.includes(gemLower)) {
                  const cutStylePattern = new RegExp(`${gemLower}\\s*(cut|center|shape|diamond|-cut)`, 'i');
                  if (cutStylePattern.test(titleLower)) {
                    return false; // Title says it's a cut style, not actual gem
                  }
                }
                return true;
              };
              
              // Check for colored gemstones in metafields (with cut-style verification)
              const hasColoredGemstonesInMetafields =
                isRealGemInMetafield(centerStone) ||
                isRealGemInMetafield(sideStone) ||
                isRealGemInMetafield(stud1Type) ||
                isRealGemInMetafield(stud2Type);
              const hasColoredGemstonesInText =
                containsColoredGemstones(p.title) || (typeof p.description === "string" && containsColoredGemstones(p.description));
              // First check that it is a stud
              const hasStudInTitle = p.title.toLowerCase().includes("stud");
              const hasStudInBody = typeof p.description === "string" && p.description.toLowerCase().includes("stud");
              const isStud = hasStudInTitle || hasStudInBody;

              const hasColoredGemstones = hasColoredGemstonesInMetafields || hasColoredGemstonesInText;

              if (filter === "Hanging & Hoop") {
                // Check for non-hanging/hoop earring styles to exclude
                const titleLower = p.title.toLowerCase();
                const descLower = typeof p.description === "string" ? p.description.toLowerCase() : "";
                
                // Keywords that indicate non-hanging styles (studs, clusters, buttons, etc.)
                const nonHangingKeywords = [
                  "stud", "cluster", "button", "flower", "mosaic", 
                  "huggie", "cuff", "climber", "crawler", "jacket"
                ];
                
                // Check if any non-hanging keyword is present
                const hasNonHangingKeyword = nonHangingKeywords.some(keyword => 
                  titleLower.includes(keyword) || descLower.includes(keyword)
                );
                
                // Keywords that indicate hanging/hoop styles (positive match)
                const hangingKeywords = [
                  "hoop", "drop", "dangle", "chandelier", "pendant", 
                  "hanging", "tassel", "fringe", "linear", "threader"
                ];
                
                // Check if any hanging keyword is present
                const hasHangingKeyword = hangingKeywords.some(keyword => 
                  titleLower.includes(keyword) || descLower.includes(keyword)
                );
                
                // Product is a hanging/hoop if it has hanging keywords OR doesn't have non-hanging keywords
                const isHangingOrHoop = hasHangingKeyword || !hasNonHangingKeyword;

                if (selectedFilters["hangingType"].length > 0) {
                  const hangingFilter = selectedFilters["hangingType"][0];
                  if (hangingFilter === "No Stones") {
                    // Check metafields AND title/description for ANY stones (diamonds + colored gemstones)
                    const hasNoStoneMetafields = !sideStone && !centerStone && !totalSideStones;
                    const titleHasDiamond = titleLower.includes("diamond");
                    const descHasDiamond = descLower.includes("diamond");
                    const titleHasColoredGems = containsColoredGemstones(p.title);
                    const descHasColoredGems = containsColoredGemstones(p.description);
                    const hasNoStones = !titleHasDiamond && !descHasDiamond && !titleHasColoredGems && !descHasColoredGems;
                    earringTypeMatches = isHangingOrHoop && hasNoStoneMetafields && hasNoStones;
                  } else if (hangingFilter === "Diamonds") {
                    // Check metafields OR title for diamonds (like Diamond Studs filter does)
                    const hasDiamondsInMetafields = 
                      sideStone?.toLowerCase() === "diamond" || 
                      centerStone?.toLowerCase() === "diamond";
                    const hasDiamondsInTitle = titleLower.includes("diamond");
                    earringTypeMatches = isHangingOrHoop && (hasDiamondsInMetafields || hasDiamondsInTitle);
                  }
                } else {
                  earringTypeMatches = isHangingOrHoop;
                }
              } else if (filter === "Diamond Studs") {
                // First check that it is a stud and has diamonds
                const hasDiamonds = centerStone?.toLowerCase() === "diamond" || 
                  stud1Type?.toLowerCase() === "diamond" || 
                  stud2Type?.toLowerCase() === "diamond" ||
                  p.title.toLowerCase().includes("diamond");
                earringTypeMatches = isStud && hasDiamonds;
                
                if (selectedFilters["studSize"].length > 0) {
                  const [min, max] = selectedFilters["studSize"][0].split("~").map(Number);

                  // Parse metafield values as floats (they come as strings)
                  const combinedWeight = parseFloat(studCombinedSize) || 0;
                  const stud1Weight = parseFloat(stud1Size) || 0;
                  const stud2Weight = parseFloat(stud2Size) || 0;
                  
                  // Use combined weight if available, otherwise sum individual stud weights
                  let totalStudWeight = combinedWeight > 0 ? combinedWeight : (stud1Weight + stud2Weight);
                  
                  // Fallback: extract weight from title if no metafield data
                  // Matches patterns like "1.50 CTW", "2.00 CT", "1.5 CARAT", "1.50CTW", "2CTW"
                  if (totalStudWeight === 0 && p.title) {
                    const titleLower = p.title.toLowerCase();
                    // Match numbers followed by ct, ctw, cttw, or carat (with optional space)
                    const weightMatch = titleLower.match(/(\d+\.?\d*)\s*(ct|ctw|cttw|carat)\b/);
                    if (weightMatch) {
                      totalStudWeight = parseFloat(weightMatch[1]) || 0;
                    }
                  }

                  // Exclude products with no weight data when filtering by size
                  if (totalStudWeight === 0) {
                    sizeMatches = false;
                  } else {
                    sizeMatches = totalStudWeight >= min && totalStudWeight <= max;
                  }
                }

              } else if (filter === "Colored Gemstone") {
                // Check if specific gemstones are selected in the submenu
                const specificGemsSelected = selectedFilters["stones"].filter(s => 
                  s !== "Colored Gemstone" && coloredGemstones.includes(s)
                );
                
                if (specificGemsSelected.length > 0) {
                  // Filter by the specific gemstones selected
                  // Cut-style gemstones need special handling to avoid matching "Emerald Cut", etc.
                  const cutStyleGemstones = ['emerald', 'marquise', 'pear', 'oval', 'cushion', 'radiant', 'princess', 'heart', 'asscher'];
                  
                  // Check metafields BUT verify against title for cut-style gems
                  const hasSpecificGemInMetafields = specificGemsSelected.some(gem => {
                    const gemLower = gem.toLowerCase();
                    const matchesMetafield = 
                      centerStone?.toLowerCase() === gemLower ||
                      sideStone?.toLowerCase() === gemLower ||
                      stud1Type?.toLowerCase() === gemLower ||
                      stud2Type?.toLowerCase() === gemLower;
                    
                    if (!matchesMetafield) return false;
                    
                    // For cut-style gemstones, verify the title doesn't indicate it's a cut style
                    // "Emerald Cut", "Emerald Diamond", "Emerald Shape", etc.
                    if (cutStyleGemstones.includes(gemLower)) {
                      const titleLower = p.title.toLowerCase();
                      const cutStylePattern = new RegExp(`${gemLower}\\s*(cut|center|shape|diamond|-cut)`, 'i');
                      if (cutStylePattern.test(titleLower)) {
                        // Title says it's a cut style, don't trust the metafield
                        return false;
                      }
                    }
                    return true;
                  });
                  
                  // Check title using stoneMatches (which has built-in cut-style exclusion)
                  const hasSpecificGemInTitle = specificGemsSelected.some(gem => 
                    stoneMatches(p.title, gem)
                  );
                  earringTypeMatches = hasSpecificGemInMetafields || hasSpecificGemInTitle;
                } else {
                  // No specific gems selected, match any colored gemstone
                  earringTypeMatches = hasColoredGemstones;
                }
              }
            }

            // Return true if all conditions match
            const matches =
              materialMatches &&
              stonesMatch &&
              priceMatches &&
              designerMatches &&
              lengthMatches &&
              shapeMatches &&
              sizeMatches &&
              diamondColorMatches &&
              diamondClarityMatches &&
              certificateMatches &&
              ringTypeMatches &&
              materialBandMatches &&
              stonesDesignerMatches &&
              genderMatches &&
              watchMaterialMatches &&
              materialTypeMatches &&
              movementMatches &&
              caseSizeMatches &&
              productTypeMatches &&
              conditionMatches &&
              earringTypeMatches &&
              hangingTypeMatches &&
              studSizeMatches;

            return matches;
          });
        }
        
        // Sort products by price (highest to lowest)
        filter_products.sort((a, b) => {
          const priceA = parseFloat(a.priceRange?.minVariantPrice?.amount || 0);
          const priceB = parseFloat(b.priceRange?.minVariantPrice?.amount || 0);
          return priceB - priceA; // Descending order (highest first)
        });
        
        const products = filter_products.slice(PRODUCTS_PER_PAGE * (currentPage - 1), currentPage * PRODUCTS_PER_PAGE);

        const totalPages = Math.ceil(filter_products.length / PRODUCTS_PER_PAGE);
        renderPagination(currentPage, totalPages);

        if (products.length > 0) {
          $(".filter-empty-state").hide();
          $(".ProductListWrapper").show();
          $(".Pagination").show();
        } else {
          // Move empty state to product area if not already there
          const emptyState = $(".filter-empty-state");
          const productArea = $(".CollectionInner__Products");
          if (emptyState.length && productArea.length && !productArea.find(".filter-empty-state").length) {
            emptyState.appendTo(productArea);
          }
          $(".filter-empty-state").show();
          $(".ProductListWrapper").hide();
          $(".Pagination").hide();
        }
        
    // Render products while hidden, then fade in after images preload
    renderProducs(products, () => {
      $(".ProductListWrapper").removeClass("is-filtering");
      
      // If a callback is provided (e.g., for scroll restoration), use it instead of scrollIntoView
      if (typeof onCompleteCallback === 'function') {
        onCompleteCallback();
      } else {
        scrollIntoView();
      }
      
      hideOverlay();
      
    });
  }

  // Render pagination with smart page number display
  // Shows: prev arrow, first 3 pages, ellipsis, current page with neighbors, ellipsis, last 3 pages, next arrow
  const renderPagination = (currentPage, totalPages) => {
    if (totalPages <= 1) {
      $(".Pagination__Nav").hide();
      return;
    }
    
    $(".Pagination__Nav").show();
    
    // Clear existing pagination items (except keep the container)
    $(".Pagination__Nav").empty();
    
    // Create prev arrow
    const prevArrow = $('<a class="Pagination__NavItem Link Link--primary" rel="prev" title="Previous page" href="#"><svg class="Icon Icon--select-arrow-left" role="presentation" viewBox="0 0 11 18"><path d="M9.5 1.5L1.5 9l8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path></svg></a>');
    if (currentPage > 1) {
      $(".Pagination__Nav").append(prevArrow);
    }
    
    // Determine which page numbers to show
    // Goal: Show 6 page numbers total with intelligent ellipsis
    const pagesToShow = [];
    
    if (totalPages <= 7) {
      // Show all pages if 7 or fewer
      for (let i = 1; i <= totalPages; i++) {
        pagesToShow.push(i);
      }
    } else {
      // Always show first page
      pagesToShow.push(1);
      
      if (currentPage <= 4) {
        // Near the start: show 1, 2, 3, 4, 5, ..., last
        pagesToShow.push(2, 3, 4, 5);
        pagesToShow.push('...');
        pagesToShow.push(totalPages);
      } else if (currentPage >= totalPages - 3) {
        // Near the end: show 1, ..., last-4, last-3, last-2, last-1, last
        pagesToShow.push('...');
        for (let i = totalPages - 4; i <= totalPages; i++) {
          pagesToShow.push(i);
        }
      } else {
        // In the middle: show 1, ..., current-1, current, current+1, ..., last
        pagesToShow.push('...');
        pagesToShow.push(currentPage - 1);
        pagesToShow.push(currentPage);
        pagesToShow.push(currentPage + 1);
        pagesToShow.push('...');
        pagesToShow.push(totalPages);
      }
    }
    
    // Render page numbers
    pagesToShow.forEach(page => {
      if (page === '...') {
        const ellipsis = $('<span class="Pagination__NavItem">…</span>');
        $(".Pagination__Nav").append(ellipsis);
      } else {
        const isActive = page === currentPage;
        const pageLink = $(`<span class="Pagination__NavItem ${isActive ? 'is-active' : 'Link Link--primary'}" style="${isActive ? 'cursor: default;' : 'cursor: pointer;'}">${page}</span>`);
        $(".Pagination__Nav").append(pageLink);
      }
    });
    
    // Create next arrow
    const nextArrow = $('<a class="Pagination__NavItem Link Link--primary" rel="next" title="Next page" href="#"><svg class="Icon Icon--select-arrow-right" role="presentation" viewBox="0 0 11 18"><path d="M1.5 1.5l8 7.5-8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path></svg></a>');
    if (currentPage < totalPages) {
      $(".Pagination__Nav").append(nextArrow);
    }
  };

  // Wait for actual DOM images to load and return a promise
  const waitForDOMImages = (imageElements) => {
    const promises = imageElements.map(img => {
      return new Promise((resolve) => {
        // If image is already loaded (cached), resolve immediately
        if (img.complete && img.naturalHeight !== 0) {
          resolve();
          return;
        }
        // Otherwise wait for load or error
        img.onload = resolve;
        img.onerror = resolve; // Resolve even on error to not block
      });
    });
    
    // Return a promise that resolves when all images load OR after a timeout
    return Promise.race([
      Promise.all(promises),
      new Promise(resolve => setTimeout(resolve, 1500)) // Max 1.5s wait for images
    ]);
  };

  const renderProducs = (products, callback) => {
    const productTiles = $(".ProductList.ProductList--grid>div");
    const primaryImages = [];

    // Debug: Log render info
    console.log('[RENDER] Rendering', products.length, 'products into', productTiles.length, 'tiles');

    productTiles.each((i, el) => {
      if (!products[i]) {
        $(el).hide();
        return;
      }
      $(el).show();
      $(el).find("a").attr("href", products[i].onlineStoreUrl);

      const imageNodes = (products[i].images.edges || []).map((img) => img.node);
      const primaryImage = imageNodes[0];
      const alternateImage = imageNodes[1] || imageNodes[0];

      if (primaryImage) {
        // Responsive sizes for product grid (4 columns on desktop, 2 on tablet, 1 on mobile)
        const imageSizes = "(min-width: 1200px) 25vw, (min-width: 750px) 33vw, (min-width: 500px) 50vw, 100vw";
        const srcsetValue = generateSrcset(primaryImage.url);
        
        // Update primary image - MUST clear lazy loading state and set ALL attributes
        const primaryImg = $(el).find(".ProductItem__Image:not(.ProductItem__Image--alternate)");
        
        // Debug: Log image update for first few images
        if (i < 3) {
          console.log(`[RENDER] Image ${i}:`, {
            product: products[i].title?.substring(0, 30),
            newSrc: primaryImage.url?.substring(0, 60),
            oldSrc: primaryImg.attr('src')?.substring(0, 60),
            hasLazyLoad: primaryImg.hasClass('Image--lazyLoad')
          });
        }
        
        // Clear lazy loading state - remove ALL lazy loading classes
        primaryImg.removeClass('Image--lazyLoad Image--fadeIn lazyload lazyloading');
        primaryImg.addClass('lazyloaded');
        
        // Set all image attributes
        primaryImg.attr("src", primaryImage.url);
        primaryImg.attr("data-src", primaryImage.url);
        primaryImg.attr("data-srcset", srcsetValue);
        primaryImg.attr("srcset", srcsetValue);
        primaryImg.attr("sizes", imageSizes);
        primaryImg.attr("data-sizes", imageSizes);
        primaryImg.removeAttr("data-widths"); // Remove old widths array
        
        // Collect the actual DOM image element for load watching
        if (primaryImg.length > 0) {
          primaryImages.push(primaryImg[0]);
        }
        
        // Update alternate image - same treatment
        const altImg = $(el).find(".ProductItem__Image--alternate");
        const altSrcsetValue = generateSrcset(alternateImage.url);
        
        altImg.removeClass('Image--lazyLoad Image--fadeIn lazyload lazyloading');
        altImg.addClass('lazyloaded');
        
        altImg.attr("src", alternateImage.url);
        altImg.attr("data-src", alternateImage.url);
        altImg.attr("data-srcset", altSrcsetValue);
        altImg.attr("srcset", altSrcsetValue);
        altImg.attr("sizes", imageSizes);
        altImg.attr("data-sizes", imageSizes);
        altImg.removeAttr("data-widths");
        
        // Update aspect ratio CSS variable for consistent image sizing
        if (primaryImage.width && primaryImage.height) {
          const aspectRatio = primaryImage.width / primaryImage.height;
          $(el).find(".AspectRatio").css("--aspect-ratio", aspectRatio);
        }
      }

      $(el).find("h2.ProductItem__Title>a").text(products[i].title);
      $(el)
        .find(".ProductItem__Price.Price")
        .text(`${formatCurrency(products[i].priceRange.minVariantPrice.amount)}`);
    });
    
    // Wait for actual DOM images to load, then call callback
    if (callback) {
      waitForDOMImages(primaryImages).then(callback);
    }
  };

  const scrollIntoView = () => {
    const productContainer = document.querySelector(".CollectionInner__Products");

    productContainer.style.scrollMarginTop = "200px";
    productContainer.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }

  // Use event delegation for pagination since elements are dynamically created
  $(document).on('click', '.Pagination__NavItem', function (e) {
    e.preventDefault();

    var ps = filter_products.length > 0 ? filter_products : all_products;
    const totalPages = Math.ceil(ps.length / PRODUCTS_PER_PAGE);
    const page = parseInt($(this).text());
    const isPrev = $(this).attr("rel") === "prev";
    const isNext = $(this).attr("rel") === "next";
    
    // Don't do anything if clicking current page, ellipsis, or arrows at boundaries
    if (currentPage === page || $(this).text().includes("…")) return;
    if (isNext && currentPage === totalPages) return;
    if (isPrev && currentPage === 1) return;

    // Handle prev/next arrows
    if (isPrev) {
      currentPage = currentPage - 1;
    } else if (isNext) {
      currentPage = currentPage + 1;
    } else if (page) {
      currentPage = page;
    } else {
      return; // Invalid click
    }

    // Update URL with page number for browser history
    const url = new URL(window.location);
    if (currentPage === 1) {
      url.searchParams.delete('page');
    } else {
      url.searchParams.set('page', currentPage);
    }
    history.pushState({ page: currentPage }, '', url);

    // Immediately fade out products and show loading
    showOverlay();
    
    // Wait for fade out transition, then render new products
    setTimeout(() => {
      const products = ps.slice(PRODUCTS_PER_PAGE * (currentPage - 1), currentPage * PRODUCTS_PER_PAGE);
      
      // Update pagination display
      renderPagination(currentPage, totalPages);
      
      // Render products and fade in after images preload
      renderProducs(products, () => {
        $(".ProductListWrapper").removeClass("is-filtering");
        scrollIntoView();
        hideOverlay();
      });
    }, 250); // Wait for fade out to complete
  });
  
  // Handle browser back/forward buttons
  window.addEventListener('popstate', function(event) {
    const urlParams = new URLSearchParams(window.location.search);
    const page = parseInt(urlParams.get('page')) || 1;
    
    if (page !== currentPage && all_products.length > 0) {
      var ps = filter_products.length > 0 ? filter_products : all_products;
      const totalPages = Math.ceil(ps.length / PRODUCTS_PER_PAGE);
      
      // Validate page number - cap to max available pages
      currentPage = Math.min(page, totalPages);
      currentPage = Math.max(currentPage, 1); // Ensure at least page 1
      
      // Fade out and show loading
      showOverlay();
      
      // Wait for fade out, then render
      setTimeout(() => {
        const products = ps.slice(PRODUCTS_PER_PAGE * (currentPage - 1), currentPage * PRODUCTS_PER_PAGE);
        
        // Update pagination display
        renderPagination(currentPage, totalPages);
        
        // Render products and fade in after images preload
        renderProducs(products, () => {
          $(".ProductListWrapper").removeClass("is-filtering");
          scrollIntoView();
          hideOverlay();
        });
      }, 250);
    }
  });

  // Save expanded state of filter sections to sessionStorage
  function saveExpandedState() {
    const expandedSections = [];
    $('.custom-filter button[aria-expanded="true"]').each(function() {
      const sectionId = $(this).attr('aria-controls') || $(this).closest('.custom-filter').attr('class');
      if (sectionId) {
        expandedSections.push(sectionId);
      }
    });
    sessionStorage.setItem('filter-expanded-sections', JSON.stringify(expandedSections));
  }
  
  // Restore expanded state of filter sections from sessionStorage
  function restoreExpandedState() {
    try {
      const expandedSections = JSON.parse(sessionStorage.getItem('filter-expanded-sections') || '[]');
      if (expandedSections.length > 0) {
        expandedSections.forEach(sectionId => {
          // Try to find button by aria-controls
          let button = $(`button[aria-controls="${sectionId}"]`);
          // If not found, try to find by class
          if (button.length === 0) {
            button = $(`.${sectionId} button[aria-expanded]`);
          }
          if (button.length > 0) {
            button.attr('aria-expanded', 'true');
          }
        });
      }
    } catch (e) {
      // Could not restore expanded state
    }
  }
  
  // Track filter section expansion - save state when user expands/collapses
  $(document).on('click', '.custom-filter button[aria-expanded]', function() {
    // Small delay to let the aria-expanded attribute update first
    setTimeout(saveExpandedState, 50);
  });
  
  // Initialize filter active indicators on all filter buttons
  function initFilterIndicators() {
    // Find ALL filter buttons - use broad selector to catch any we might miss
    const buttons = $('.custom-filter > button');
    
    buttons.each(function() {
      // Only add wrapper if not already present
      if ($(this).find('.filter-label-wrapper').length === 0) {
        
        // Try to find the icon - could be .Icon class or svg directly
        let icon = $(this).find('.Icon').detach();
        if (icon.length === 0) {
          icon = $(this).find('svg').detach();
        }
        
        // Get the text content (label) from the button
        const labelText = $(this).text().trim();
        
        // Clear button content and rebuild with wrapper
        $(this).empty();
        
        // Create wrapper that spans the full button width
        const wrapper = $('<span class="filter-label-wrapper"></span>');
        
        // Create inner container for indicator and label (left side)
        const labelContainer = $('<span class="filter-label-text"></span>');
        labelContainer.append('<span class="filter-active-indicator"></span>');
        labelContainer.append(document.createTextNode(' ' + labelText + ' '));
        
        // Add label container and icon to wrapper (icon on right)
        wrapper.append(labelContainer);
        if (icon.length > 0) {
          wrapper.append(icon);
        }
        
        // Add wrapper to button
        $(this).append(wrapper);
      }
    });
  }
  
  // Update filter active indicators based on current filter state
  function updateFilterIndicators() {
    // Make sure indicators exist - if not, initialize them first
    if ($('.filter-active-indicator').length === 0) {
      initFilterIndicators();
    }
    
    // Map filter types to their container classes
    const filterMappings = {
      'fiter-price': () => selectedFilters.price && selectedFilters.price.length > 0,
      'fiter-material': () => selectedFilters.material && selectedFilters.material.length > 0,
      'fiter-material-bands': () => selectedFilters.material_band && selectedFilters.material_band.length > 0,
      'fiter-material-type': () => selectedFilters.materialType && selectedFilters.materialType.length > 0,
      'fiter-stones': () => selectedFilters.stones && selectedFilters.stones.length > 0,
      'fiter-stones-designers': () => selectedFilters.stonesDesigner && selectedFilters.stonesDesigner.length > 0,
      'fiter-designer': () => selectedFilters.designer && selectedFilters.designer.length > 0,
      'fiter-length': () => selectedFilters.length && selectedFilters.length.length > 0,
      'fiter-stone-shape': () => selectedFilters.stoneShape && selectedFilters.stoneShape.length > 0,
      'fiter-stone-size': () => selectedFilters.stoneSize && selectedFilters.stoneSize.length > 0,
      'fiter-diamond-color': () => selectedFilters.diamondColor && selectedFilters.diamondColor.length > 0,
      'fiter-diamond-clarity': () => selectedFilters.diamondClarity && selectedFilters.diamondClarity.length > 0,
      'fiter-certificate-lab': () => selectedFilters.certificate && selectedFilters.certificate.length > 0,
      'fiter-ring-type': () => selectedFilters.ringType && selectedFilters.ringType.length > 0,
      'fiter-gender': () => selectedFilters.gender && selectedFilters.gender.length > 0,
      'fiter-movement': () => selectedFilters.movement && selectedFilters.movement.length > 0,
      'fiter-case-size': () => selectedFilters.caseSize && selectedFilters.caseSize.length > 0,
      'fiter-product-type': () => selectedFilters.productType && selectedFilters.productType.length > 0,
      'fiter-condition': () => selectedFilters.condition && selectedFilters.condition.length > 0,
      'fiter-earring-type': () => selectedFilters.earringType && selectedFilters.earringType.length > 0,
    };
    
    // Update each filter section
    let activeCount = 0;
    Object.keys(filterMappings).forEach(filterClass => {
      const $filterSection = $(`.${filterClass}`);
      if ($filterSection.length > 0) {
        try {
          const isActive = filterMappings[filterClass]();
          if (isActive) {
            $filterSection.addClass('has-active-filter');
            activeCount++;
          } else {
            $filterSection.removeClass('has-active-filter');
          }
        } catch (e) {
          console.error(`Error checking filter ${filterClass}:`, e);
        }
      }
    });
    
    // Show/hide the "Clear All Filters" button
    const $clearAllButton = $('#filter-clear-all');
    if (activeCount > 0) {
      $clearAllButton.addClass('is-visible');
    } else {
      $clearAllButton.removeClass('is-visible');
    }
  }
  
  // Initialize indicators on page load
  initFilterIndicators();
  
  // Initialize mobile filter badge
  updateMobileFilterBadge();

  // Restore filter state from checked checkboxes (for back button navigation)
  function restoreFilterStateFromCheckboxes() {
    // Reset filters first
    selectedFilters = getEmptyFilters();
    let hasActiveFilters = false;
    
    // Check price filters
    $(priceSelector + ':checked').each(function() {
      const values = $(this).val().split("~");
      selectedFilters["price"] = values.map((v) => parseInt(v));
      hasActiveFilters = true;
    });
    
    // Check material filters
    $(materialFitlerSelector + ':checked').each(function() {
      selectedFilters["material"] = [$(this).val()];
      hasActiveFilters = true;
    });
    
    // Check material bands filters
    $(materialBandsFitlerSelector + ':checked').each(function() {
      selectedFilters["material_band"] = [$(this).val()];
      hasActiveFilters = true;
    });
    
    // Check stones filters
    $(stonesFitlerSelector + ':checked').each(function() {
      const val = $(this).val();
      if (val === "Colored Gemstone") {
        selectedFilters["stones"] = ['Colored Gemstone'];
        // Show the sub-menu for colored gemstones
        $(this).parent().next().show();
      } else {
        selectedFilters["stones"] = [val];
      }
      hasActiveFilters = true;
    });
    
    // Check stones designer filters
    $(stonesDesignerFitlerSelector + ':checked').each(function() {
      const val = $(this).val();
      if (val === "Colored") {
        selectedFilters["stonesDesigner"] = ['Colored Gemstone'];
      } else {
        selectedFilters["stonesDesigner"] = stoneFilters[val] || [val];
      }
      hasActiveFilters = true;
    });
    
    // Check sub-menu (colored gemstones) filters
    $(subMenuSelector + ':checked').each(function() {
      // Show the sub-menu container
      $(this).closest('.sub-menu').show();
      if (!selectedFilters["stones"].includes($(this).val())) {
        selectedFilters["stones"].push($(this).val());
      }
      hasActiveFilters = true;
    });
    
    // Check designer filters
    $(designerSelector + ':checked').each(function() {
      selectedFilters["designer"] = [$(this).val()];
      hasActiveFilters = true;
    });
    
    // Check length filters
    $(lengthSelector + ':checked').each(function() {
      selectedFilters["length"] = [$(this).val()];
      hasActiveFilters = true;
    });
    
    // Check stone shape filters
    $(stoneShapeSelector + ':checked').each(function() {
      if (!selectedFilters["stoneShape"].includes($(this).val())) {
        selectedFilters["stoneShape"].push($(this).val());
      }
      hasActiveFilters = true;
    });
    
    // Check stone size filters
    $(stoneSizeSelector + ':checked').each(function() {
      const values = $(this).val().split("~");
      selectedFilters["stoneSize"] = values.map((v) => parseFloat(v));
      hasActiveFilters = true;
    });
    
    // Check diamond color filters
    $(diamondColorSelector + ':checked').each(function() {
      selectedFilters["diamondColor"] = [$(this).val()];
      hasActiveFilters = true;
    });
    
    // Check diamond clarity filters
    $(diamondClaritySelector + ':checked').each(function() {
      selectedFilters["diamondClarity"] = [$(this).val()];
      hasActiveFilters = true;
    });
    
    // Check certificate filters
    $(certificateLabSelector + ':checked').each(function() {
      selectedFilters["certificate"] = [$(this).val()];
      hasActiveFilters = true;
    });
    
    // Check ring type filters
    $(ringTypeSelector + ':checked').each(function() {
      selectedFilters["ringType"] = [$(this).val()];
      hasActiveFilters = true;
    });
    
    // Check gender filters
    $(genderSelector + ':checked').each(function() {
      selectedFilters["gender"] = [$(this).val()];
      hasActiveFilters = true;
    });
    
    // Check material type filters (watches)
    $(materialTypeSelector + ':checked').each(function() {
      selectedFilters["materialType"] = [$(this).val()];
      hasActiveFilters = true;
    });
    
    // Check movement filters
    $(movementSelector + ':checked').each(function() {
      selectedFilters["movement"] = [$(this).val()];
      hasActiveFilters = true;
    });
    
    // Check case size filters
    $(caseSizeSelector + ':checked').each(function() {
      const values = $(this).val().split("~");
      selectedFilters["caseSize"] = values.map((v) => parseFloat(v));
      hasActiveFilters = true;
    });
    
    // Check product type filters
    $(productTypeSelector + ':checked').each(function() {
      selectedFilters["productType"] = [$(this).val()];
      hasActiveFilters = true;
    });
    
    // Check condition filters
    $(conditionSelector + ':checked').each(function() {
      selectedFilters["condition"] = [$(this).val()];
      hasActiveFilters = true;
    });
    
    // Check earring type filters
    $(earringTypeSelector + ':checked').each(function() {
      const val = $(this).val();
      selectedFilters["earringType"] = [val];
      // Show sub-menu if it exists
      if ($(this).hasClass('has-submenu')) {
        $(this).parent().next().show();
      }
      hasActiveFilters = true;
    });
    
    // Check hanging type sub-filters
    $(hangingTypeSelector + ':checked').each(function() {
      $(this).closest('.sub-menu').show();
      selectedFilters["hangingType"] = [$(this).val()];
      hasActiveFilters = true;
    });
    
    // Check stud size sub-filters
    $(studSizeSelector + ':checked').each(function() {
      $(this).closest('.sub-menu').show();
      const values = $(this).val().split("~");
      selectedFilters["studSize"] = values.map((v) => parseFloat(v));
      hasActiveFilters = true;
    });
    
    // Check earring colored gemstone sub-filters
    $(earringColoredGemstoneSelector + ':checked').each(function() {
      $(this).closest('.sub-menu').show();
      if (!selectedFilters["stones"].includes($(this).val())) {
        selectedFilters["stones"].push($(this).val());
      }
      hasActiveFilters = true;
    });
    
    return hasActiveFilters;
  }
  
  // Restore checkbox UI state from selectedFilters object
  function restoreCheckboxUIFromFilters() {
    // Price filter
    if (selectedFilters.price && selectedFilters.price.length === 2) {
      const priceValue = selectedFilters.price.join('~');
      $(priceSelector).filter(`[value="${priceValue}"]`).prop('checked', true);
    }
    
    // Material filter
    if (selectedFilters.material && selectedFilters.material.length > 0) {
      // Find the checkbox that matches - check against materalfilters mapping
      $(materialFitlerSelector).each(function() {
        const val = $(this).val();
        const filterVals = materalfilters[val] || [val];
        if (filterVals.some(v => selectedFilters.material.includes(v)) || selectedFilters.material.includes(val)) {
          $(this).prop('checked', true);
        }
      });
    }
    
    // Stones filter
    if (selectedFilters.stones && selectedFilters.stones.length > 0) {
      $(stonesFitlerSelector).each(function() {
        if (selectedFilters.stones.includes($(this).val())) {
          $(this).prop('checked', true);
          if ($(this).hasClass('has-submenu')) {
            $(this).parent().next().show();
          }
        }
      });
      // Check sub-menu checkboxes
      $(subMenuSelector).each(function() {
        if (selectedFilters.stones.includes($(this).val())) {
          $(this).prop('checked', true);
          $(this).closest('.sub-menu').show();
        }
      });
    }
    
    // Designer filter
    if (selectedFilters.designer && selectedFilters.designer.length > 0) {
      $(designerSelector).filter(`[value="${selectedFilters.designer[0]}"]`).prop('checked', true);
    }
    
    // Stone shape filter
    if (selectedFilters.stoneShape && selectedFilters.stoneShape.length > 0) {
      selectedFilters.stoneShape.forEach(shape => {
        $(stoneShapeSelector).filter(`[value="${shape}"]`).prop('checked', true);
      });
    }
    
    // Stone size filter
    if (selectedFilters.stoneSize && selectedFilters.stoneSize.length > 0) {
      $(stoneSizeSelector).filter(`[value="${selectedFilters.stoneSize[0]}"]`).prop('checked', true);
    }
    
    // Diamond color filter
    if (selectedFilters.diamondColor && selectedFilters.diamondColor.length > 0) {
      $(diamondColorSelector).each(function() {
        const filterVals = diamondColorFitlers[$(this).val()] || [];
        if (filterVals.some(v => selectedFilters.diamondColor.includes(v))) {
          $(this).prop('checked', true);
        }
      });
    }
    
    // Diamond clarity filter
    if (selectedFilters.diamondClarity && selectedFilters.diamondClarity.length > 0) {
      $(diamondClaritySelector).each(function() {
        const filterVals = diamondClarityFilters[$(this).val()] || [];
        if (filterVals.some(v => selectedFilters.diamondClarity.includes(v))) {
          $(this).prop('checked', true);
        }
      });
    }
    
    // Certificate filter
    if (selectedFilters.certificate && selectedFilters.certificate.length > 0) {
      $(certificateLabSelector).filter(`[value="${selectedFilters.certificate[0]}"]`).prop('checked', true);
    }
    
    // Gender filter
    if (selectedFilters.gender && selectedFilters.gender.length > 0) {
      $(genderSelector).filter(`[value="${selectedFilters.gender[0]}"]`).prop('checked', true);
    }
    
    // Material type filter (watches)
    if (selectedFilters.materialType && selectedFilters.materialType.length > 0) {
      $(materialTypeSelector).each(function() {
        const filterVals = watchMaterialFitlers[$(this).val()] || [$(this).val()];
        if (filterVals.some(v => selectedFilters.materialType.includes(v))) {
          $(this).prop('checked', true);
        }
      });
    }
    
    // Movement filter
    if (selectedFilters.movement && selectedFilters.movement.length > 0) {
      $(movementSelector).filter(`[value="${selectedFilters.movement[0]}"]`).prop('checked', true);
    }
    
    // Case size filter
    if (selectedFilters.caseSize && selectedFilters.caseSize.length > 0) {
      $(caseSizeSelector).filter(`[value="${selectedFilters.caseSize[0]}"]`).prop('checked', true);
    }
    
    // Condition filter
    if (selectedFilters.condition && selectedFilters.condition.length > 0) {
      selectedFilters.condition.forEach(cond => {
        $(conditionSelector).filter(`[value="${cond}"]`).prop('checked', true);
      });
    }
    
    // Earring type filter
    if (selectedFilters.earringType && selectedFilters.earringType.length > 0) {
      $(earringTypeSelector).filter(`[value="${selectedFilters.earringType[0]}"]`).prop('checked', true);
    }
    
  }

  // Check if we need to restore filters (back/forward navigation)
  let hasFiltersToRestore = Object.values(selectedFilters).some(arr => arr && arr.length > 0);
  
  // Fallback: If no filters were restored but sessionStorage has filters for this collection,
  // try to restore them. We restore if:
  // 1. Navigation type is back_forward
  // 2. Or the referrer is from the same site (likely came from a product page)
  // 3. Or there are already checked checkboxes (browser restored form state)
  if (!hasFiltersToRestore) {
    const savedFilters = sessionStorage.getItem('filter-state');
    const savedHandle = sessionStorage.getItem('filter-collection-handle');
    const currentHandle = window.location.pathname.split("/")[2];
    
    if (savedFilters && savedHandle === currentHandle) {
      try {
        const restored = JSON.parse(savedFilters);
        const hasRestored = Object.values(restored).some(arr => arr && arr.length > 0);
        if (hasRestored) {
          // Check various signals for back navigation
          const perfEntries = performance.getEntriesByType('navigation');
          const navType = perfEntries.length > 0 ? perfEntries[0].type : 'unknown';
          const isBackForward = navType === 'back_forward';
          
          // Check if referrer is from same site (likely came from product page)
          const referrer = document.referrer;
          const isFromSameSite = referrer && referrer.includes(window.location.hostname);
          const isFromProductPage = isFromSameSite && referrer.includes('/products/');
          
          // Check if there are any checked checkboxes (browser restored form state)
          const hasCheckedFilters = $('input[type="checkbox"]:checked', '.CollectionInner__Sidebar').length > 0;
          
          // Restore if any signal suggests we came back to this page
          if (isBackForward || isFromProductPage || hasCheckedFilters) {
            Object.assign(selectedFilters, restored);
            hasFiltersToRestore = true;
          } else {
          }
        }
      } catch (e) {
        // Failed to parse saved filters
      }
    }
  }
  
  if (hasFiltersToRestore) {
    // Restore checkbox UI from selectedFilters
    restoreCheckboxUIFromFilters();
    updateFilterIndicators();
    
    // Wait for products then apply filters
    const restoreTimer = setInterval(() => {
      if (all_products.length > 0) {
        clearInterval(restoreTimer);
        performFiltering();
      }
    }, 100);
    setTimeout(() => clearInterval(restoreTimer), 10000);
    
  } else {
    // Save collection handle for future back/forward detection
    sessionStorage.setItem('filter-collection-handle', handle);
    
    // Render all products (no filters)
    const pageTimer = setInterval(() => {
      if (all_products.length > 0) {
        clearInterval(pageTimer);
        filter_products = all_products;
        const totalPages = Math.ceil(all_products.length / PRODUCTS_PER_PAGE);
        
        currentPage = Math.min(currentPage, totalPages);
        currentPage = Math.max(currentPage, 1);
        
        const products = all_products.slice(PRODUCTS_PER_PAGE * (currentPage - 1), currentPage * PRODUCTS_PER_PAGE);
        renderProducs(products);
        renderPagination(currentPage, totalPages);
      }
    }, 100);
    
    setTimeout(() => clearInterval(pageTimer), 10000);
  }
  
  // Handle pageshow event (fires on back/forward navigation from bfcache)
  window.addEventListener('pageshow', function(event) {
    // Check if this is ANY back/forward navigation (bfcache OR HTTP cache)
    const navType = performance.getEntriesByType?.('navigation')[0]?.type;
    const isBackForward = event.persisted || navType === 'back_forward' || window._wasBackForwardNav;
    
    console.log('[jQuery pageshow handler]', {
      persisted: event.persisted,
      navType: navType,
      _wasBackForwardNav: window._wasBackForwardNav,
      isBackForward: isBackForward
    });
    
    if (isBackForward) {
      // Page was restored from bfcache OR reloaded via back/forward navigation
      console.log('%c[BACK/FORWARD NAVIGATION DETECTED]', 'background: #0a0; color: #fff;', 
        event.persisted ? '(bfcache)' : '(HTTP cache)');
      
      // Re-initialize filter indicators (they may have been affected by bfcache)
      initFilterIndicators();
      
      // Show overlay immediately to hide any stale content
      showOverlay();
      
      // IMPORTANT: Clear ALL product images first to prevent stale cached images
      // The browser may restore DOM with old images from cache
      $(".ProductItem__Image, .ProductItem img, .ProductList img").each(function() {
        // Set to transparent placeholder to clear cached image
        $(this).attr("src", "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7");
        $(this).removeAttr("srcset");
        $(this).removeAttr("data-srcset");
        $(this).removeAttr("data-src");
        $(this).removeAttr("data-widths");
        $(this).removeAttr("data-sizes");
        $(this).removeAttr("data-media-id");
        // Remove ALL lazy loading classes (both theme's Image--lazyLoad and lazysizes standard)
        $(this).removeClass("lazyloaded lazyload Image--lazyLoad Image--fadeIn lazyloading").addClass("lazyloaded");
      });
      
      // ALWAYS restore from sessionStorage in bfcache restore - this is definitely a back navigation
      const savedFilters = sessionStorage.getItem('filter-state');
      const savedHandle = sessionStorage.getItem('filter-collection-handle');
      const currentHandle = window.location.pathname.split("/")[2];
      
      if (savedFilters && savedHandle === currentHandle) {
        try {
          const restored = JSON.parse(savedFilters);
          const hasRestored = Object.values(restored).some(arr => arr && arr.length > 0);
          if (hasRestored) {
            // Replace selectedFilters entirely with restored state
            Object.keys(selectedFilters).forEach(key => {
              selectedFilters[key] = restored[key] || [];
            });
            restoreCheckboxUIFromFilters();
            updateFilterIndicators();
          }
        } catch (e) {
          console.log('Failed to restore filters in pageshow:', e);
        }
      }
      
      // Restore sub-menu visibility based on checked checkboxes
      // Show Colored Gemstone sub-menu if it's checked
      if ($(stonesFitlerSelector + '[value="Colored Gemstone"]:checked').length > 0) {
        $(stonesFitlerSelector + '[value="Colored Gemstone"]').parent().next('.sub-menu').show();
      }
      
      // Show earring type sub-menus if checked
      $('.fiter-earring-type .has-submenu:checked').each(function() {
        $(this).parent().next('.sub-menu').show();
      });
      
      // Show any sub-menu with checked options inside
      $('.sub-menu').each(function() {
        if ($(this).find('input:checked').length > 0) {
          $(this).show();
        }
      });
      
      // Re-apply filters and re-render products
      const hasFiltersNow = Object.values(selectedFilters).some(arr => arr && arr.length > 0);
      
      // Function to restore scroll position after render
      const restoreScrollPosition = () => {
        const savedScrollY = sessionStorage.getItem('collection-scroll-position');
        const savedScrollPath = sessionStorage.getItem('collection-scroll-path');
        
        if (savedScrollY && savedScrollPath === window.location.pathname) {
          // Small delay to ensure DOM is fully updated
          requestAnimationFrame(() => {
            window.scrollTo(0, parseInt(savedScrollY, 10));
          });
        }
      };
      
      const renderAfterRestore = () => {
        if (hasFiltersNow) {
          performFiltering(restoreScrollPosition);
        } else {
          // Even without filters, re-render to fix any image mismatches
          const totalPages = Math.ceil(all_products.length / PRODUCTS_PER_PAGE);
          const products = all_products.slice(PRODUCTS_PER_PAGE * (currentPage - 1), currentPage * PRODUCTS_PER_PAGE);
          renderProducs(products, () => {
            hideOverlay();
            restoreScrollPosition();
          });
        }
      };
      
      if (all_products.length > 0) {
        renderAfterRestore();
      } else {
        // Products not loaded yet - wait for them
        const maxWait = 10000; // 10 seconds
        const startTime = Date.now();
        
        const waitForProducts = () => {
          if (all_products.length > 0) {
            renderAfterRestore();
          } else if (Date.now() - startTime < maxWait) {
            setTimeout(waitForProducts, 100);
          } else {
            console.error('Timeout waiting for products after bfcache restore');
            hideOverlay();
          }
        };
        waitForProducts();
      }
    }
  });
  
  // Ensure empty state is hidden and products are shown on fresh page load
  $(".filter-empty-state").hide();
  $(".ProductListWrapper").show();
  $(".Pagination").show();
  
  // Clear all filters and reset to showing all products
  window.clearAllFilters = function() {
    // Show loading state
    showOverlay();
    
    // Reset selectedFilters to fresh empty state
    selectedFilters = getEmptyFilters();
    
    // Uncheck all filter checkboxes
    $('.custom-filter input[type="checkbox"]').prop('checked', false);
    
    // Hide all sub-menus
    $('.custom-filter .sub-menu').hide();
    
    // Collapse all filter expanders
    document.querySelectorAll('.custom-filter button[aria-expanded]').forEach(button => {
      button.setAttribute('aria-expanded', 'false');
    });
    
    // Clear filter active indicators
    updateFilterIndicators();
    
    // Update mobile filter badge
    updateMobileFilterBadge();
    
    // Clear localStorage and sessionStorage
    localStorage.removeItem("filter-handle");
    localStorage.removeItem("filters");
    sessionStorage.removeItem("filter-state");
    sessionStorage.removeItem("filter-expanded-sections");
    
    // Reset to page 1
    currentPage = 1;
    
    // Clear page from URL
    const url = new URL(window.location);
    url.searchParams.delete('page');
    history.replaceState({ page: 1 }, '', url);
    
    // Reset filter_products to all products
    filter_products = all_products;
    
    // Hide empty state, show products and pagination
    $(".filter-empty-state").hide();
    $(".ProductListWrapper").show();
    $(".Pagination").show();
    
    // Re-render all products
    if (all_products.length > 0) {
      const products = all_products.slice(0, PRODUCTS_PER_PAGE);
      
      // Update pagination
      const totalPages = Math.ceil(all_products.length / PRODUCTS_PER_PAGE);
      renderPagination(1, totalPages);
      
      // Render products and fade in after images preload
      renderProducs(products, () => {
        $(".ProductListWrapper").removeClass("is-filtering");
        hideOverlay();
      });
    } else {
      hideOverlay();
    }
  };
  });
}

// Start initialization - wait for jQuery if needed
initializeFilterSystem();

// Transition duration in ms (should match CSS transition duration)
const TRANSITION_DURATION = 150;
const MIN_LOADING_TIME = 500; // Minimum time to show loading overlay

// Track when overlay was shown
let overlayShowTime = 0;

// Move spinner overlay to products container on init
const initOverlayPosition = () => {
  const spinnerOverlay = document.querySelector(".spinner-overlay");
  const productsContainer = document.querySelector(".CollectionInner__Products");
  
  if (spinnerOverlay && productsContainer && !productsContainer.contains(spinnerOverlay)) {
    productsContainer.insertBefore(spinnerOverlay, productsContainer.firstChild);
  }
};

// Initialize overlay position when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initOverlayPosition);
} else {
  initOverlayPosition();
}

const showOverlay = () => {
  const spinnerOverlay = document.querySelector(".spinner-overlay");
  const productWrapper = document.querySelector(".ProductListWrapper");

  // Record when overlay was shown
  overlayShowTime = Date.now();
  
  // Show the spinner and fade out products simultaneously
  if (spinnerOverlay) {
    spinnerOverlay.classList.add("show");
  }
  if (productWrapper) {
    productWrapper.classList.add("is-filtering");
  }
};

const hideOverlay = () => {
  const spinnerOverlay = document.querySelector(".spinner-overlay");
  const productWrapper = document.querySelector(".ProductListWrapper");

  // Calculate how long overlay has been shown
  const elapsedTime = Date.now() - overlayShowTime;
  const remainingTime = Math.max(0, MIN_LOADING_TIME - elapsedTime);
  
  // Delay hiding if minimum time hasn't elapsed
  setTimeout(() => {
    // Hide spinner and fade in products simultaneously
    if (spinnerOverlay) {
      spinnerOverlay.classList.remove("show");
    }
    if (productWrapper) {
      productWrapper.classList.remove("is-filtering");
      // Clear any inline styles set during bfcache restore
      productWrapper.style.opacity = '';
      productWrapper.style.visibility = '';
    }
    // Remove bfcache loading class to allow products to show
    document.body.classList.remove('bfcache-loading');
  }, remainingTime);
};

// Wait for fade-out transition to complete before executing callback
const waitForFadeOut = (callback) => {
  setTimeout(callback, TRANSITION_DURATION);
};

const formatCurrency = (value, currency = "USD", locale = "en-US") => {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency,
    minimumFractionDigits: value % 1 ? 2 : 0, // Show decimal places only if the value has them
    maximumFractionDigits: 2,
  }).format(value);
};

function generateSrcset(baseUrl, sizes = [200, 300, 400, 600, 800, 900, 1000, 1200]) {
  if (!baseUrl) return [];
  // Find the file extension, e.g., ".jpg", ".png"
  const extensionIndex = baseUrl.lastIndexOf(".");
  const queryIndex = baseUrl.indexOf("?");
  const extension = baseUrl.substring(extensionIndex, queryIndex !== -1 ? queryIndex : baseUrl.length);

  // Base URL without dimensions and without the file extension
  const baseWithoutExtension = baseUrl.substring(0, extensionIndex);

  // Generate srcset string
  const srcset = sizes
    .map((size) => {
      return `${baseWithoutExtension}_${size}x${extension} ${size}w`;
    })
    .join(", ");

  return srcset;
}

async function fetchAllProductsInCollection(collectionHandle, metafieldValue) {
  let allProducts = [];
  let hasNextPage = true;
  let cursor = null;

  while (hasNextPage) {
    const query = `
      {
          collection(handle: "${collectionHandle}") {
              id
              products(
                  filters: {productMetafield: {namespace: "custom", key: "material", value: "${metafieldValue}"}}
                  first: ${GRAPHQL_PAGE_SIZE}${cursor ? `, after: "${cursor}"` : ""}
              ) {
                  edges {
                      node {
                          id
                          metafield(key: "material", namespace: "custom") {
                              value
                          }
                      }
                  }
                  pageInfo {
                      hasNextPage
                      endCursor
                  }
              }
          }
      }`;

    try {
      const response = await fetch(GRAPHQL_API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN,
        },
        body: JSON.stringify({
          query,
        }),
      });

      const jsonResponse = await response.json();

      // Log any GraphQL errors
      if (jsonResponse.errors) {
        console.error("GraphQL Errors:", jsonResponse.errors);
      }

      if (!jsonResponse.data || !jsonResponse.data.collection) {
        console.error("Collection not found or no data returned for the collection handle:", collectionHandle);
        console.error("Full response:", jsonResponse);
        break;
      }

      const products = jsonResponse.data.collection.products.edges.map((edge) => edge.node);
      allProducts = allProducts.concat(products);

      // Check if there's a next page
      hasNextPage = jsonResponse.data.collection.products.pageInfo.hasNextPage;
      cursor = jsonResponse.data.collection.products.pageInfo.endCursor;
    } catch (error) {
      console.error("Error fetching products:", error);
      break;
    }
  }

  return allProducts;
}

// Session cache for products - avoids re-fetching on back/forward navigation
const CACHE_KEY_PREFIX = 'filter_products_cache_';
const CACHE_DURATION_MS = 5 * 60 * 1000; // 5 minutes

function getCachedProducts(collectionHandle) {
  try {
    const cacheKey = CACHE_KEY_PREFIX + collectionHandle;
    const cached = sessionStorage.getItem(cacheKey);
    if (cached) {
      const { products, timestamp } = JSON.parse(cached);
      if (Date.now() - timestamp < CACHE_DURATION_MS) {
        return products;
      }
      // Cache expired
      sessionStorage.removeItem(cacheKey);
    }
  } catch (e) {
    console.warn('Cache read error:', e);
  }
  return null;
}

function setCachedProducts(collectionHandle, products) {
  try {
    const cacheKey = CACHE_KEY_PREFIX + collectionHandle;
    sessionStorage.setItem(cacheKey, JSON.stringify({
      products,
      timestamp: Date.now()
    }));
  } catch (e) {
    console.warn('Cache write error (storage may be full):', e);
  }
}

async function fetchAllProducts(collectionHandle) {
  // Check cache first
  const cached = getCachedProducts(collectionHandle);
  if (cached) {
    return cached;
  }
  
  // Prevent duplicate fetches - reuse existing promise if fetch is in progress
  if (isFetching && fetchPromise) {
    return fetchPromise;
  }
  
  // Mark fetch as in progress
  isFetching = true;
  
  // Create the fetch promise
  fetchPromise = (async () => {
    let allProducts = [];
    let hasNextPage = true;
    let cursor = null;
    let pageCount = 0;

    const startTime = performance.now();

    while (hasNextPage) {
      pageCount++;
      const query = `
        {
            collection(handle: "${collectionHandle}") {
                id
                products(
                    first: ${GRAPHQL_PAGE_SIZE}${cursor ? `, after: "${cursor}"` : ""}
                ) {
                    edges {
                        node {
                            id
                            tags
                            metafields(
                              identifiers: [{key: "total_side_stones", namespace: "custom"},{key: "material", namespace: "custom"}, {key: "side_gemstones", namespace: "custom"},
                              {key: "center_stone", namespace: "custom"}, {key: "length_in", namespace: "custom"},
                              {key: "center_stone_shape", namespace: "custom"}, {key: "side_stones_shape", namespace: "custom"},
                              {key: "center_stone_weight_ct", namespace: "custom"}, {key: "center_stone_color", namespace: "custom"},
                              {key: "center_stone_clarity", namespace: "custom"}, {key: "certificate", namespace: "custom"}, 
                              {key: "gender", namespace: "custom"}, {key: "movement", namespace: "custom"}, {key: "case_size_mm", namespace: "custom"},
                              {key: "earring_1_gemstone_1_total_weight_cttw_", namespace: "custom"}, {key: "earring_1_gemstone_1_type", namespace: "custom"},
                              {key: "earring_2_gemstone_2_type_", namespace: "custom"}, {key: "stud_1_size_ct", namespace: "custom"},
                              {key: "stud_2_size_ct", namespace: "custom"}
                              ]
                            ) {
                              type
                              value
                              key
                            }
                            onlineStoreUrl
                            images(first: 2) {
                              edges {
                                node {
                                  url
                                  width
                                  height
                                }
                              }
                            }
                            title
                            description
                            priceRange {
                              minVariantPrice {
                                amount
                                currencyCode
                              }
                            }
                            vendor
                            productType
                        }
                    }
                    pageInfo {
                        hasNextPage
                        endCursor
                    }
                }
            }
        }`;

      try {
        const response = await fetch(GRAPHQL_API_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN,
          },
          body: JSON.stringify({ query }),
        });

        const jsonResponse = await response.json();

        if (jsonResponse.errors) {
          console.error("GraphQL Errors:", jsonResponse.errors);
        }

        if (!jsonResponse.data || !jsonResponse.data.collection) {
          console.error("Collection not found:", collectionHandle);
          break;
        }

        const products = jsonResponse.data.collection.products.edges.map((edge) => edge.node);
        allProducts = allProducts.concat(products);

        hasNextPage = jsonResponse.data.collection.products.pageInfo.hasNextPage;
        cursor = jsonResponse.data.collection.products.pageInfo.endCursor;
        
      } catch (error) {
        console.error("Error fetching products:", error);
        break;
      }
    }

    
    // Cache the results
    if (allProducts.length > 0) {
      setCachedProducts(collectionHandle, allProducts);
    }
    
    return allProducts;
  })();
  
  try {
    const result = await fetchPromise;
    return result;
  } finally {
    // Reset fetch state
    isFetching = false;
    fetchPromise = null;
  }
}
